import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { styled, Link, Icon, Button, Paper, Box, Typography, Avatar, List, Accordion, ListItem, AccordionSummary, AccordionDetails, Divider } from '@mui/material';
import { useState } from 'react';
import { InView } from 'react-intersection-observer';
import Launch from '@mui/icons-material/Launch';
import ChevronRight from '@mui/icons-material/ChevronRight';
import LockOutlined from '@mui/icons-material/LockOutlined';
import { styled as styled$1 } from '@mui/material/styles';
import Downloading from '@mui/icons-material/DownloadForOfflineRounded';
import DOMPurify from 'dompurify';
import { domToReact, htmlToDOM } from 'html-react-parser';
import ReactDOMServer from 'react-dom/server';
import OpenInNew from '@mui/icons-material/OpenInNewRounded';
import ExpandMore from '@mui/icons-material/ExpandMore';

const resetListStyling = (theme) => ({
    '> li > ol': {
        gap: theme.spacing(1),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        paddingInlineStart: theme.spacing(3),
        '> li': {
            marginBottom: 0,
            paddingInlineStart: 0,
            flexDirection: 'row',
            justifyContent: 'initial',
            '::before': {
                paddingRight: theme.spacing(2),
                width: 'initial',
                height: 'initial',
                borderRadius: 'initial',
                textAlign: 'initial',
                justifyContent: 'initial',
                flexDirection: 'row',
                position: 'initial',
                fontSize: 'initial',
                left: theme.spacing(-5),
                color: theme.palette.text?.primary,
                background: 'none',
                fontWeight: 'normal',
                content: 'counter(list)',
            },
        },
    },
    '> li > ul': {
        gap: theme.spacing(1),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        paddingInlineStart: theme.spacing(5),
        ' > li': {
            marginBottom: 0,
            paddingLeft: theme.spacing(1),
            '::marker': {
                fontSize: 'initial',
            },
        },
    },
});

const StyledOl = styled('ol')(({ theme }) => ({
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(5),
    counterReset: 'list',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    '> li': {
        justifyContent: 'center',
        paddingInlineStart: theme.spacing(1),
        counterIncrement: 'list',
        listStyle: 'none',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        br: {
            display: 'none',
        },
        '&::before': {
            ...theme.typography.subtitle2,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            position: 'absolute',
            left: theme.spacing(-5),
            color: theme.palette.secondary?.dark,
            background: theme.palette.secondary?.light,
            textAlign: 'center',
            height: '32px',
            width: '32px',
            borderRadius: '50%',
            content: 'counter(list)',
        },
        a: {
            display: 'inline-block',
            marginTop: theme.spacing(1),
        },
        p: {
            marginBottom: 0,
        },
    },
    ...resetListStyling(theme),
}));
const OrderedList = (attribs) => {
    return jsx(StyledOl, { ...attribs });
};

const StyledUl = styled('ul')(({ theme }) => ({
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(5),
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    gap: theme.spacing(2),
    paddingInlineStart: theme.spacing(4),
    listStyle: 'disc',
    '> li': {
        paddingLeft: theme.spacing(1),
        fontSize: '1rem',
        '::marker': {
            fontSize: '1.125rem',
            color: theme.palette.secondary?.main,
        },
        a: {
            display: 'inline-block',
            marginTop: theme.spacing(1),
        },
    },
    ...resetListStyling(theme),
}));
const UnorderedList = (attribs) => {
    return jsx(StyledUl, { ...attribs });
};

/* eslint-disable @typescript-eslint/restrict-template-expressions */
const getImageQuery = (imageUrl, width) => {
    const searchParams = new URLSearchParams({
        width: width.toString(),
        dpr: window.devicePixelRatio.toString(),
        auto: 'webp',
        q: '80,75',
    });
    return `${imageUrl}?${searchParams.toString()}`;
};
const isLinkExternal = (href) => {
    if (!href)
        return false;
    return (href.startsWith('http') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:'));
};

const LazyLoadWrapper = ({ component, className, children, }) => {
    const [render, setRender] = useState(false);
    return (jsx(InView, { as: component, onChange: setRender, className: className, triggerOnce: true, children: render && children }));
};

const AppshellLink = ({ url, text = '', fontSize = 16, fontWeight = 400, showIcon = true, ...rest }) => {
    const externalLink = url ? isLinkExternal(url) : false;
    const ariaLabel = externalLink ? `${text} (öppnas i ny flik)` : text;
    const shouldShowIcon = showIcon && externalLink;
    return (jsx(Fragment, { children: url && text && (jsxs(Link, { target: externalLink ? '_blank' : undefined, rel: externalLink ? 'noreferrer' : undefined, href: url, fontSize: fontSize, fontWeight: fontWeight, display: "flex", alignItems: "center", columnGap: "8px", "aria-label": ariaLabel, "data-testid": "link", underline: "hover", sx: { hyphens: 'auto' }, ...(externalLink && { component: 'a' }), ...rest, children: [shouldShowIcon && jsx(Launch, { fontSize: 'small' }), text] })) }));
};

var abc = 1;
var ac_unit = 1;
var access_alarm = 1;
var access_alarms = 1;
var access_time = 1;
var access_time_filled = 1;
var accessibility = 1;
var accessibility_new = 1;
var accessible = 1;
var accessible_forward = 1;
var account_balance = 1;
var account_balance_wallet = 1;
var account_box = 1;
var account_circle = 1;
var account_tree = 1;
var ad_units = 1;
var adb = 1;
var add = 1;
var add_a_photo = 1;
var add_alarm = 1;
var add_alert = 1;
var add_box = 1;
var add_business = 1;
var add_card = 1;
var add_circle = 1;
var add_circle_outline = 1;
var add_comment = 1;
var add_home = 1;
var add_home_work = 1;
var add_ic_call = 1;
var add_link = 1;
var add_location = 1;
var add_location_alt = 1;
var add_moderator = 1;
var add_photo_alternate = 1;
var add_reaction = 1;
var add_road = 1;
var add_shopping_cart = 1;
var add_task = 1;
var add_to_drive = 1;
var add_to_homescreen = 1;
var add_to_photos = 1;
var add_to_queue = 1;
var addchart = 1;
var adf_scanner = 1;
var adjust = 1;
var admin_panel_settings = 1;
var agriculture = 1;
var air = 1;
var airline_seat_flat = 1;
var airline_seat_flatangled = 1;
var airline_seat_individualsuite = 1;
var airline_seat_legroomextra = 1;
var airline_seat_legroomnormal = 1;
var airline_seat_legroomreduced = 1;
var airline_seat_reclineextra = 1;
var airline_seat_reclinenormal = 1;
var airline_stops = 1;
var airlines = 1;
var airplane_ticket = 1;
var airplanemode_active = 1;
var airplanemode_inactive = 1;
var airplay = 1;
var airport_shuttle = 1;
var alarm = 1;
var alarm_add = 1;
var alarm_off = 1;
var alarm_on = 1;
var album = 1;
var align_horizontal_center = 1;
var align_horizontal_left = 1;
var align_horizontal_right = 1;
var align_vertical_bottom = 1;
var align_vertical_center = 1;
var align_vertical_top = 1;
var all_inbox = 1;
var all_inclusive = 1;
var all_out = 1;
var alt_route = 1;
var alternate_email = 1;
var analytics = 1;
var anchor = 1;
var android = 1;
var animation = 1;
var announcement = 1;
var aod = 1;
var apartment = 1;
var api = 1;
var app_blocking = 1;
var app_registration = 1;
var app_settings_alt = 1;
var app_shortcut = 1;
var approval = 1;
var apps = 1;
var apps_outage = 1;
var architecture = 1;
var archive = 1;
var arrow_back = 1;
var arrow_back_ios = 1;
var arrow_back_iosnew = 1;
var arrow_circle_down = 1;
var arrow_circle_left = 1;
var arrow_circle_right = 1;
var arrow_circle_up = 1;
var arrow_downward = 1;
var arrow_drop_down = 1;
var arrow_drop_downcircle = 1;
var arrow_drop_up = 1;
var arrow_forward = 1;
var arrow_forward_ios = 1;
var arrow_left = 1;
var arrow_outward = 1;
var arrow_right = 1;
var arrow_right_alt = 1;
var arrow_upward = 1;
var art_track = 1;
var article = 1;
var aspect_ratio = 1;
var assessment = 1;
var assignment = 1;
var assignment_ind = 1;
var assignment_late = 1;
var assignment_return = 1;
var assignment_returned = 1;
var assignment_turned_in = 1;
var assist_walker = 1;
var assistant = 1;
var assistant_direction = 1;
var assistant_photo = 1;
var assured_workload = 1;
var atm = 1;
var attach_email = 1;
var attach_file = 1;
var attach_money = 1;
var attachment = 1;
var attractions = 1;
var attribution = 1;
var audio_file = 1;
var audiotrack = 1;
var auto_awesome = 1;
var auto_awesome_mosaic = 1;
var auto_awesome_motion = 1;
var auto_delete = 1;
var auto_fix_high = 1;
var auto_fix_normal = 1;
var auto_fix_off = 1;
var auto_graph = 1;
var auto_mode = 1;
var auto_stories = 1;
var autofps_select = 1;
var autorenew = 1;
var av_timer = 1;
var baby_changing_station = 1;
var backpack = 1;
var backspace = 1;
var backup = 1;
var backup_table = 1;
var badge = 1;
var bakery_dining = 1;
var balance = 1;
var balcony = 1;
var ballot = 1;
var bar_chart = 1;
var batch_prediction = 1;
var bathroom = 1;
var bathtub = 1;
var battery_0_bar = 1;
var battery_1_bar = 1;
var battery_2_bar = 1;
var battery_3_bar = 1;
var battery_4_bar = 1;
var battery_5_bar = 1;
var battery_6_bar = 1;
var battery_alert = 1;
var battery_charging_full = 1;
var battery_full = 1;
var battery_saver = 1;
var battery_std = 1;
var battery_unknown = 1;
var beach_access = 1;
var bed = 1;
var bedroom_baby = 1;
var bedroom_child = 1;
var bedroom_parent = 1;
var bedtime = 1;
var bedtime_off = 1;
var beenhere = 1;
var bento = 1;
var bike_scooter = 1;
var biotech = 1;
var blender = 1;
var blind = 1;
var blinds = 1;
var blinds_closed = 1;
var block = 1;
var bloodtype = 1;
var bluetooth = 1;
var bluetooth_audio = 1;
var bluetooth_connected = 1;
var bluetooth_disabled = 1;
var bluetooth_drive = 1;
var bluetooth_searching = 1;
var blur_circular = 1;
var blur_linear = 1;
var blur_off = 1;
var blur_on = 1;
var bolt = 1;
var book = 1;
var book_online = 1;
var bookmark = 1;
var bookmark_add = 1;
var bookmark_added = 1;
var bookmark_border = 1;
var bookmark_remove = 1;
var bookmarks = 1;
var border_all = 1;
var border_bottom = 1;
var border_clear = 1;
var border_color = 1;
var border_horizontal = 1;
var border_inner = 1;
var border_left = 1;
var border_outer = 1;
var border_right = 1;
var border_style = 1;
var border_top = 1;
var border_vertical = 1;
var boy = 1;
var branding_watermark = 1;
var breakfast_dining = 1;
var brightness_1 = 1;
var brightness_2 = 1;
var brightness_3 = 1;
var brightness_4 = 1;
var brightness_5 = 1;
var brightness_6 = 1;
var brightness_7 = 1;
var brightness_auto = 1;
var brightness_high = 1;
var brightness_low = 1;
var brightness_medium = 1;
var broadcast_on_home = 1;
var broadcast_on_personal = 1;
var broken_image = 1;
var browse_gallery = 1;
var browser_not_supported = 1;
var browser_updated = 1;
var brunch_dining = 1;
var brush = 1;
var bubble_chart = 1;
var bug_report = 1;
var build = 1;
var build_circle = 1;
var bungalow = 1;
var burst_mode = 1;
var bus_alert = 1;
var business = 1;
var business_center = 1;
var cabin = 1;
var cable = 1;
var cached = 1;
var cake = 1;
var calculate = 1;
var calendar_month = 1;
var calendar_today = 1;
var calendar_view_day = 1;
var calendar_view_month = 1;
var calendar_view_week = 1;
var call = 1;
var call_end = 1;
var call_made = 1;
var call_merge = 1;
var call_missed = 1;
var call_missed_outgoing = 1;
var call_received = 1;
var call_split = 1;
var call_to_action = 1;
var camera = 1;
var camera_alt = 1;
var camera_enhance = 1;
var camera_front = 1;
var camera_indoor = 1;
var camera_outdoor = 1;
var camera_rear = 1;
var camera_roll = 1;
var cameraswitch = 1;
var campaign = 1;
var cancel = 1;
var cancel_presentation = 1;
var cancel_schedule_send = 1;
var candlestick_chart = 1;
var car_crash = 1;
var car_rental = 1;
var car_repair = 1;
var card_giftcard = 1;
var card_membership = 1;
var card_travel = 1;
var carpenter = 1;
var cases = 1;
var casino = 1;
var cast = 1;
var cast_connected = 1;
var cast_for_education = 1;
var castle = 1;
var catching_pokemon = 1;
var category = 1;
var celebration = 1;
var cell_tower = 1;
var cell_wifi = 1;
var center_focus_strong = 1;
var center_focus_weak = 1;
var chair = 1;
var chair_alt = 1;
var chalet = 1;
var change_circle = 1;
var change_history = 1;
var charging_station = 1;
var chat = 1;
var chat_bubble = 1;
var chat_bubble_outline = 1;
var check = 1;
var check_box = 1;
var check_box_outlineblank = 1;
var check_circle = 1;
var check_circle_outline = 1;
var checkroom = 1;
var chevron_left = 1;
var chevron_right = 1;
var child_care = 1;
var child_friendly = 1;
var chrome_reader_mode = 1;
var church = 1;
var circle = 1;
var circle_notifications = 1;
var clean_hands = 1;
var cleaning_services = 1;
var clear = 1;
var clear_all = 1;
var close = 1;
var close_fullscreen = 1;
var closed_caption = 1;
var closed_caption_disabled = 1;
var closed_caption_off = 1;
var cloud = 1;
var cloud_circle = 1;
var cloud_done = 1;
var cloud_download = 1;
var cloud_off = 1;
var cloud_queue = 1;
var cloud_sync = 1;
var cloud_upload = 1;
var co2 = 1;
var co_present = 1;
var code = 1;
var code_off = 1;
var coffee = 1;
var coffee_maker = 1;
var collections = 1;
var collections_bookmark = 1;
var color_lens = 1;
var colorize = 1;
var comment = 1;
var comment_bank = 1;
var comments_disabled = 1;
var commit = 1;
var commute = 1;
var compare = 1;
var compare_arrows = 1;
var compass_calibration = 1;
var compress = 1;
var computer = 1;
var confirmation_number = 1;
var connect_without_contact = 1;
var connected_tv = 1;
var connecting_airports = 1;
var construction = 1;
var contact_emergency = 1;
var contact_mail = 1;
var contact_page = 1;
var contact_phone = 1;
var contact_support = 1;
var contactless = 1;
var contacts = 1;
var content_copy = 1;
var content_cut = 1;
var content_paste = 1;
var content_paste_go = 1;
var content_paste_off = 1;
var content_paste_search = 1;
var contrast = 1;
var control_camera = 1;
var control_point = 1;
var control_point_duplicate = 1;
var cookie = 1;
var copy_all = 1;
var copyright = 1;
var coronavirus = 1;
var corporate_fare = 1;
var cottage = 1;
var countertops = 1;
var create = 1;
var create_new_folder = 1;
var credit_card = 1;
var credit_card_off = 1;
var credit_score = 1;
var crib = 1;
var crisis_alert = 1;
var crop = 1;
var crop169 = 1;
var crop32 = 1;
var crop54 = 1;
var crop75 = 1;
var crop_din = 1;
var crop_free = 1;
var crop_landscape = 1;
var crop_original = 1;
var crop_portrait = 1;
var crop_rotate = 1;
var crop_square = 1;
var css = 1;
var currency_bitcoin = 1;
var currency_exchange = 1;
var currency_franc = 1;
var currency_lira = 1;
var currency_pound = 1;
var currency_ruble = 1;
var currency_rupee = 1;
var currency_yen = 1;
var currency_yuan = 1;
var curtains = 1;
var curtains_closed = 1;
var cyclone = 1;
var dangerous = 1;
var dark_mode = 1;
var dashboard = 1;
var dashboard_customize = 1;
var data_array = 1;
var data_object = 1;
var data_saver_off = 1;
var data_saver_on = 1;
var data_thresholding = 1;
var data_usage = 1;
var dataset = 1;
var dataset_linked = 1;
var date_range = 1;
var deblur = 1;
var deck = 1;
var dehaze = 1;
var delete_forever = 1;
var delete_outline = 1;
var delete_sweep = 1;
var delivery_dining = 1;
var density_large = 1;
var density_medium = 1;
var density_small = 1;
var departure_board = 1;
var description = 1;
var deselect = 1;
var design_services = 1;
var desk = 1;
var desktop_access_disabled = 1;
var desktop_mac = 1;
var desktop_windows = 1;
var details = 1;
var developer_board = 1;
var developer_board_off = 1;
var developer_mode = 1;
var device_hub = 1;
var device_thermostat = 1;
var device_unknown = 1;
var devices = 1;
var devices_fold = 1;
var devices_other = 1;
var dialer_sip = 1;
var dialpad = 1;
var diamond = 1;
var difference = 1;
var dining = 1;
var dinner_dining = 1;
var directions = 1;
var directions_bike = 1;
var directions_boat = 1;
var directions_boat_filled = 1;
var directions_bus = 1;
var directions_bus_filled = 1;
var directions_car = 1;
var directions_car_filled = 1;
var directions_off = 1;
var directions_railway = 1;
var directions_railway_filled = 1;
var directions_run = 1;
var directions_subway = 1;
var directions_subway_filled = 1;
var directions_transit = 1;
var directions_transit_filled = 1;
var directions_walk = 1;
var dirty_lens = 1;
var disabled_by_default = 1;
var disc_full = 1;
var discount = 1;
var display_settings = 1;
var diversity_1 = 1;
var diversity_2 = 1;
var diversity_3 = 1;
var dns = 1;
var do_disturb = 1;
var do_disturb_alt = 1;
var do_disturb_off = 1;
var do_disturb_on = 1;
var do_not_disturb = 1;
var do_not_disturbalt = 1;
var do_not_disturboff = 1;
var do_not_disturbon = 1;
var do_not_disturbontotalsilence = 1;
var do_not_step = 1;
var do_not_touch = 1;
var dock = 1;
var document_scanner = 1;
var domain = 1;
var domain_add = 1;
var domain_disabled = 1;
var domain_verification = 1;
var done = 1;
var done_all = 1;
var done_outline = 1;
var donut_large = 1;
var donut_small = 1;
var door_back = 1;
var door_front = 1;
var door_sliding = 1;
var doorbell = 1;
var double_arrow = 1;
var downhill_skiing = 1;
var download = 1;
var download_done = 1;
var download_for_offline = 1;
var downloading = 1;
var drafts = 1;
var drag_handle = 1;
var drag_indicator = 1;
var drive_eta = 1;
var drive_file_move = 1;
var drive_file_rename_outline = 1;
var drive_folder_upload = 1;
var dry = 1;
var dry_cleaning = 1;
var duo = 1;
var dvr = 1;
var dynamic_feed = 1;
var dynamic_form = 1;
var e_mobiledata = 1;
var earbuds = 1;
var earbuds_battery = 1;
var east = 1;
var edgesensor_high = 1;
var edgesensor_low = 1;
var edit = 1;
var edit_attributes = 1;
var edit_location = 1;
var edit_location_alt = 1;
var edit_notifications = 1;
var edit_off = 1;
var edit_road = 1;
var egg = 1;
var egg_alt = 1;
var eject = 1;
var elderly = 1;
var elderly_woman = 1;
var electric_bike = 1;
var electric_bolt = 1;
var electric_car = 1;
var electric_meter = 1;
var electric_moped = 1;
var electric_rickshaw = 1;
var electric_scooter = 1;
var electrical_services = 1;
var elevator = 1;
var email = 1;
var emergency_recording = 1;
var emergency_share = 1;
var emoji_emotions = 1;
var emoji_events = 1;
var emoji_flags = 1;
var emoji_food_beverage = 1;
var emoji_nature = 1;
var emoji_objects = 1;
var emoji_people = 1;
var emoji_symbols = 1;
var emoji_transportation = 1;
var energy_savings_leaf = 1;
var engineering = 1;
var enhanced_encryption = 1;
var equalizer = 1;
var error = 1;
var error_outline = 1;
var escalator = 1;
var escalator_warning = 1;
var euro = 1;
var euro_symbol = 1;
var ev_station = 1;
var event = 1;
var event_available = 1;
var event_busy = 1;
var event_note = 1;
var event_repeat = 1;
var event_seat = 1;
var exit_to_app = 1;
var expand = 1;
var expand_circle_down = 1;
var expand_less = 1;
var expand_more = 1;
var explicit = 1;
var explore = 1;
var explore_off = 1;
var exposure = 1;
var extension = 1;
var extension_off = 1;
var face = 1;
var face2 = 1;
var face3 = 1;
var face4 = 1;
var face5 = 1;
var face6 = 1;
var face_retouching_natural = 1;
var face_retouching_off = 1;
var facebook = 1;
var fact_check = 1;
var factory = 1;
var family_restroom = 1;
var fast_forward = 1;
var fast_rewind = 1;
var fastfood = 1;
var favorite = 1;
var favorite_border = 1;
var fax = 1;
var featured_play_list = 1;
var featured_video = 1;
var feed = 1;
var feedback = 1;
var female = 1;
var fence = 1;
var festival = 1;
var fiber_dvr = 1;
var fiber_manual_record = 1;
var fiber_new = 1;
var fiber_pin = 1;
var fiber_smart_record = 1;
var file_copy = 1;
var file_download = 1;
var file_download_done = 1;
var file_download_off = 1;
var file_open = 1;
var file_present = 1;
var file_upload = 1;
var filter = 1;
var filter1 = 1;
var filter2 = 1;
var filter3 = 1;
var filter4 = 1;
var filter5 = 1;
var filter6 = 1;
var filter7 = 1;
var filter8 = 1;
var filter9 = 1;
var filter9_plus = 1;
var filter_alt = 1;
var filter_alt_off = 1;
var filter_b_andw = 1;
var filter_center_focus = 1;
var filter_drama = 1;
var filter_frames = 1;
var filter_hdr = 1;
var filter_list = 1;
var filter_list_off = 1;
var filter_none = 1;
var filter_tilt_shift = 1;
var filter_vintage = 1;
var find_in_page = 1;
var find_replace = 1;
var fingerprint = 1;
var fire_extinguisher = 1;
var fire_hydrant_alt = 1;
var fire_truck = 1;
var fireplace = 1;
var first_page = 1;
var fit_screen = 1;
var fitbit = 1;
var fitness_center = 1;
var flag = 1;
var flag_circle = 1;
var flaky = 1;
var flare = 1;
var flash_auto = 1;
var flash_off = 1;
var flash_on = 1;
var flashlight_off = 1;
var flashlight_on = 1;
var flatware = 1;
var flight = 1;
var flight_class = 1;
var flight_land = 1;
var flight_takeoff = 1;
var flip = 1;
var flip_camera_android = 1;
var flip_camera_ios = 1;
var flip_to_back = 1;
var flip_to_front = 1;
var flood = 1;
var fluorescent = 1;
var flutter_dash = 1;
var fmd_bad = 1;
var fmd_good = 1;
var folder = 1;
var folder_copy = 1;
var folder_delete = 1;
var folder_off = 1;
var folder_open = 1;
var folder_shared = 1;
var folder_special = 1;
var folder_zip = 1;
var follow_the_signs = 1;
var font_download = 1;
var font_download_off = 1;
var food_bank = 1;
var forest = 1;
var fork_left = 1;
var fork_right = 1;
var format_align_center = 1;
var format_align_justify = 1;
var format_align_left = 1;
var format_align_right = 1;
var format_bold = 1;
var format_clear = 1;
var format_color_fill = 1;
var format_color_reset = 1;
var format_color_text = 1;
var format_indent_decrease = 1;
var format_indent_increase = 1;
var format_italic = 1;
var format_line_spacing = 1;
var format_list_bulleted = 1;
var format_list_numbered = 1;
var format_list_numberedrtl = 1;
var format_overline = 1;
var format_paint = 1;
var format_quote = 1;
var format_shapes = 1;
var format_size = 1;
var format_strikethrough = 1;
var format_textdirection_l_to_r = 1;
var format_textdirection_r_to_l = 1;
var format_underlined = 1;
var fort = 1;
var forum = 1;
var forward = 1;
var forward10 = 1;
var forward30 = 1;
var forward5 = 1;
var forward_to_inbox = 1;
var foundation = 1;
var free_breakfast = 1;
var fullscreen = 1;
var fullscreen_exit = 1;
var functions = 1;
var g_mobiledata = 1;
var g_translate = 1;
var gamepad = 1;
var games = 1;
var garage = 1;
var gas_meter = 1;
var gavel = 1;
var gesture = 1;
var get_app = 1;
var gif = 1;
var gif_box = 1;
var girl = 1;
var gite = 1;
var golf_course = 1;
var gpp_bad = 1;
var gpp_good = 1;
var gpp_maybe = 1;
var gps_fixed = 1;
var gps_not_fixed = 1;
var gps_off = 1;
var grade = 1;
var gradient = 1;
var grading = 1;
var grain = 1;
var graphic_eq = 1;
var grass = 1;
var grid_3x3 = 1;
var grid_4x4 = 1;
var grid_goldenratio = 1;
var grid_off = 1;
var grid_on = 1;
var grid_view = 1;
var group = 1;
var group_add = 1;
var group_remove = 1;
var group_work = 1;
var groups = 1;
var groups2 = 1;
var groups3 = 1;
var h_mobiledata = 1;
var h_plus_mobiledata = 1;
var hail = 1;
var handshake = 1;
var handyman = 1;
var hardware = 1;
var hd = 1;
var hdr_auto = 1;
var hdr_auto_select = 1;
var hdr_enhanced_select = 1;
var hdr_off = 1;
var hdr_off_select = 1;
var hdr_on = 1;
var hdr_on_select = 1;
var hdr_plus = 1;
var hdr_strong = 1;
var hdr_weak = 1;
var headphones = 1;
var headphones_battery = 1;
var headset = 1;
var headset_mic = 1;
var headset_off = 1;
var healing = 1;
var health_and_safety = 1;
var hearing = 1;
var hearing_disabled = 1;
var heart_broken = 1;
var heat_pump = 1;
var height = 1;
var help = 1;
var help_center = 1;
var help_outline = 1;
var hevc = 1;
var hexagon = 1;
var hide_image = 1;
var hide_source = 1;
var high_quality = 1;
var highlight = 1;
var highlight_alt = 1;
var highlight_off = 1;
var hiking = 1;
var history = 1;
var history_edu = 1;
var history_toggle_off = 1;
var hive = 1;
var hls = 1;
var hls_off = 1;
var holiday_village = 1;
var home = 1;
var home_max = 1;
var home_mini = 1;
var home_repair_service = 1;
var home_work = 1;
var horizontal_rule = 1;
var horizontal_split = 1;
var hot_tub = 1;
var hotel = 1;
var hourglass_bottom = 1;
var hourglass_disabled = 1;
var hourglass_empty = 1;
var hourglass_full = 1;
var hourglass_top = 1;
var house = 1;
var house_siding = 1;
var houseboat = 1;
var how_to_reg = 1;
var how_to_vote = 1;
var html = 1;
var http = 1;
var https = 1;
var hub = 1;
var hvac = 1;
var ice_skating = 1;
var icecream = 1;
var image = 1;
var image_aspect_ratio = 1;
var image_not_supported = 1;
var image_search = 1;
var imagesearch_roller = 1;
var import_contacts = 1;
var import_export = 1;
var important_devices = 1;
var inbox = 1;
var indeterminate_check_box = 1;
var info = 1;
var input = 1;
var insert_chart = 1;
var insert_comment = 1;
var insert_drive_file = 1;
var insert_emoticon = 1;
var insert_invitation = 1;
var insert_link = 1;
var insert_page_break = 1;
var insert_photo = 1;
var insights = 1;
var install_desktop = 1;
var install_mobile = 1;
var integration_instructions = 1;
var interests = 1;
var interpreter_mode = 1;
var inventory = 1;
var inventory2 = 1;
var invert_colors = 1;
var invert_colors_off = 1;
var ios_share = 1;
var iron = 1;
var iso = 1;
var javascript = 1;
var join_full = 1;
var join_inner = 1;
var join_left = 1;
var join_right = 1;
var kayaking = 1;
var kebab_dining = 1;
var key = 1;
var key_off = 1;
var keyboard = 1;
var keyboard_alt = 1;
var keyboard_arrow_down = 1;
var keyboard_arrow_left = 1;
var keyboard_arrow_right = 1;
var keyboard_arrow_up = 1;
var keyboard_backspace = 1;
var keyboard_capslock = 1;
var keyboard_command_key = 1;
var keyboard_control_key = 1;
var keyboard_double_arrowdown = 1;
var keyboard_double_arrowleft = 1;
var keyboard_double_arrowright = 1;
var keyboard_double_arrowup = 1;
var keyboard_hide = 1;
var keyboard_option_key = 1;
var keyboard_return = 1;
var keyboard_tab = 1;
var keyboard_voice = 1;
var king_bed = 1;
var kitchen = 1;
var kitesurfing = 1;
var label = 1;
var label_important = 1;
var label_off = 1;
var lan = 1;
var landscape = 1;
var landslide = 1;
var language = 1;
var laptop = 1;
var laptop_chromebook = 1;
var laptop_mac = 1;
var laptop_windows = 1;
var last_page = 1;
var launch = 1;
var layers = 1;
var layers_clear = 1;
var leaderboard = 1;
var leak_add = 1;
var leak_remove = 1;
var legend_toggle = 1;
var lens = 1;
var lens_blur = 1;
var library_add = 1;
var library_add_check = 1;
var library_books = 1;
var library_music = 1;
var light = 1;
var light_mode = 1;
var lightbulb = 1;
var lightbulb_circle = 1;
var line_axis = 1;
var line_style = 1;
var line_weight = 1;
var linear_scale = 1;
var link = 1;
var link_off = 1;
var linked_camera = 1;
var liquor = 1;
var list = 1;
var list_alt = 1;
var live_help = 1;
var live_tv = 1;
var living = 1;
var local_activity = 1;
var local_airport = 1;
var local_atm = 1;
var local_bar = 1;
var local_cafe = 1;
var local_car_wash = 1;
var local_convenience_store = 1;
var local_dining = 1;
var local_drink = 1;
var local_fire_department = 1;
var local_florist = 1;
var local_gas_station = 1;
var local_grocery_store = 1;
var local_hospital = 1;
var local_hotel = 1;
var local_laundry_service = 1;
var local_library = 1;
var local_mall = 1;
var local_movies = 1;
var local_offer = 1;
var local_parking = 1;
var local_pharmacy = 1;
var local_phone = 1;
var local_pizza = 1;
var local_play = 1;
var local_police = 1;
var local_post_office = 1;
var local_printshop = 1;
var local_see = 1;
var local_shipping = 1;
var local_taxi = 1;
var location_city = 1;
var location_disabled = 1;
var location_off = 1;
var location_on = 1;
var location_searching = 1;
var lock = 1;
var lock_clock = 1;
var lock_open = 1;
var lock_person = 1;
var lock_reset = 1;
var login = 1;
var logo_dev = 1;
var logout = 1;
var looks = 1;
var looks3 = 1;
var looks4 = 1;
var looks5 = 1;
var looks6 = 1;
var looks_one = 1;
var looks_two = 1;
var loop = 1;
var loupe = 1;
var low_priority = 1;
var loyalty = 1;
var lte_mobiledata = 1;
var lte_plus_mobiledata = 1;
var luggage = 1;
var lunch_dining = 1;
var lyrics = 1;
var macro_off = 1;
var mail = 1;
var mail_lock = 1;
var mail_outline = 1;
var male = 1;
var man = 1;
var man2 = 1;
var man3 = 1;
var man4 = 1;
var manage_accounts = 1;
var manage_history = 1;
var manage_search = 1;
var map = 1;
var maps_home_work = 1;
var maps_ugc = 1;
var margin = 1;
var mark_as_unread = 1;
var mark_chat_read = 1;
var mark_chat_unread = 1;
var mark_email_read = 1;
var mark_email_unread = 1;
var mark_unread_chat_alt = 1;
var markunread = 1;
var markunread_mailbox = 1;
var masks = 1;
var maximize = 1;
var media_bluetooth_off = 1;
var media_bluetooth_on = 1;
var mediation = 1;
var medical_information = 1;
var medical_services = 1;
var medication = 1;
var medication_liquid = 1;
var meeting_room = 1;
var memory = 1;
var menu = 1;
var menu_book = 1;
var menu_open = 1;
var merge = 1;
var merge_type = 1;
var message = 1;
var mic = 1;
var mic_external_off = 1;
var mic_external_on = 1;
var mic_none = 1;
var mic_off = 1;
var microwave = 1;
var military_tech = 1;
var minimize = 1;
var minor_crash = 1;
var miscellaneous_services = 1;
var missed_video_call = 1;
var mms = 1;
var mobile_friendly = 1;
var mobile_off = 1;
var mobile_screen_share = 1;
var mobiledata_off = 1;
var mode = 1;
var mode_comment = 1;
var mode_edit = 1;
var mode_edit_outline = 1;
var mode_fan_off = 1;
var mode_night = 1;
var mode_of_travel = 1;
var mode_standby = 1;
var model_training = 1;
var monetization_on = 1;
var money = 1;
var money_off = 1;
var money_off_csred = 1;
var monitor = 1;
var monitor_heart = 1;
var monitor_weight = 1;
var monochrome_photos = 1;
var mood = 1;
var mood_bad = 1;
var moped = 1;
var more = 1;
var more_horiz = 1;
var more_time = 1;
var more_vert = 1;
var mosque = 1;
var motion_photos_auto = 1;
var motion_photos_off = 1;
var mouse = 1;
var move_down = 1;
var move_to_inbox = 1;
var move_up = 1;
var movie = 1;
var movie_creation = 1;
var movie_filter = 1;
var moving = 1;
var mp = 1;
var multiline_chart = 1;
var multiple_stop = 1;
var museum = 1;
var music_note = 1;
var music_off = 1;
var music_video = 1;
var my_location = 1;
var nat = 1;
var nature = 1;
var nature_people = 1;
var navigate_before = 1;
var navigate_next = 1;
var navigation = 1;
var near_me = 1;
var near_me_disabled = 1;
var nearby_error = 1;
var nearby_off = 1;
var nest_cam_wired_stand = 1;
var network_cell = 1;
var network_check = 1;
var network_locked = 1;
var network_ping = 1;
var network_wifi = 1;
var network_wifi1_bar = 1;
var network_wifi2_bar = 1;
var network_wifi3_bar = 1;
var new_releases = 1;
var newspaper = 1;
var next_plan = 1;
var next_week = 1;
var nfc = 1;
var night_shelter = 1;
var nightlife = 1;
var nightlight = 1;
var nightlight_round = 1;
var nights_stay = 1;
var no_accounts = 1;
var no_adult_content = 1;
var no_backpack = 1;
var no_cell = 1;
var no_crash = 1;
var no_drinks = 1;
var no_encryption = 1;
var no_encryption_gmailerrorred = 1;
var no_flash = 1;
var no_food = 1;
var no_luggage = 1;
var no_meals = 1;
var no_meeting_room = 1;
var no_photography = 1;
var no_sim = 1;
var no_stroller = 1;
var no_transfer = 1;
var noise_aware = 1;
var noise_control_off = 1;
var nordic_walking = 1;
var north = 1;
var north_east = 1;
var north_west = 1;
var not_accessible = 1;
var not_interested = 1;
var not_listed_location = 1;
var not_started = 1;
var note = 1;
var note_add = 1;
var note_alt = 1;
var notes = 1;
var notification_add = 1;
var notification_important = 1;
var notifications = 1;
var notifications_active = 1;
var notifications_none = 1;
var notifications_off = 1;
var notifications_paused = 1;
var numbers = 1;
var offline_bolt = 1;
var offline_pin = 1;
var offline_share = 1;
var oil_barrel = 1;
var on_device_training = 1;
var ondemand_video = 1;
var online_prediction = 1;
var opacity = 1;
var open_in_browser = 1;
var open_in_full = 1;
var open_in_new = 1;
var open_in_newoff = 1;
var open_with = 1;
var other_houses = 1;
var outbound = 1;
var outbox = 1;
var outdoor_grill = 1;
var outlet = 1;
var output = 1;
var padding = 1;
var pages = 1;
var pageview = 1;
var paid = 1;
var palette = 1;
var pan_tool = 1;
var pan_tool_alt = 1;
var panorama = 1;
var panorama_fish_eye = 1;
var panorama_horizontal = 1;
var panorama_horizontal_select = 1;
var panorama_photosphere = 1;
var panorama_photosphere_select = 1;
var panorama_vertical = 1;
var panorama_vertical_select = 1;
var panorama_wide_angle = 1;
var panorama_wide_angleselect = 1;
var paragliding = 1;
var park = 1;
var party_mode = 1;
var password = 1;
var pattern = 1;
var pause = 1;
var pause_circle = 1;
var pause_circle_filled = 1;
var pause_circle_outline = 1;
var pause_presentation = 1;
var payment = 1;
var payments = 1;
var pedal_bike = 1;
var pending = 1;
var pending_actions = 1;
var pentagon = 1;
var people = 1;
var people_alt = 1;
var people_outline = 1;
var percent = 1;
var perm_camera_mic = 1;
var perm_contact_calendar = 1;
var perm_data_setting = 1;
var perm_device_information = 1;
var perm_identity = 1;
var perm_media = 1;
var perm_phone_msg = 1;
var perm_scan_wifi = 1;
var person = 1;
var person2 = 1;
var person3 = 1;
var person4 = 1;
var person_add = 1;
var person_add_alt = 1;
var person_add_alt1 = 1;
var person_add_disabled = 1;
var person_off = 1;
var person_outline = 1;
var person_pin = 1;
var person_pin_circle = 1;
var person_remove = 1;
var person_remove_alt1 = 1;
var person_search = 1;
var personal_video = 1;
var pest_control = 1;
var pest_control_rodent = 1;
var pets = 1;
var phishing = 1;
var phone = 1;
var phone_android = 1;
var phone_bluetooth_speaker = 1;
var phone_callback = 1;
var phone_disabled = 1;
var phone_enabled = 1;
var phone_forwarded = 1;
var phone_in_talk = 1;
var phone_iphone = 1;
var phone_locked = 1;
var phone_missed = 1;
var phone_paused = 1;
var phonelink = 1;
var phonelink_erase = 1;
var phonelink_lock = 1;
var phonelink_off = 1;
var phonelink_ring = 1;
var phonelink_setup = 1;
var photo = 1;
var photo_album = 1;
var photo_camera = 1;
var photo_camera_back = 1;
var photo_camera_front = 1;
var photo_filter = 1;
var photo_library = 1;
var photo_size_selectactual = 1;
var photo_size_selectlarge = 1;
var photo_size_selectsmall = 1;
var php = 1;
var piano = 1;
var piano_off = 1;
var picture_as_pdf = 1;
var picture_in_picture = 1;
var picture_in_picturealt = 1;
var pie_chart = 1;
var pie_chart_outline = 1;
var pin = 1;
var pin_drop = 1;
var pinch = 1;
var pivot_table_chart = 1;
var pix = 1;
var place = 1;
var plagiarism = 1;
var play_arrow = 1;
var play_circle = 1;
var play_circle_filled = 1;
var play_circle_filledwhite = 1;
var play_circle_outline = 1;
var play_disabled = 1;
var play_for_work = 1;
var play_lesson = 1;
var playlist_add = 1;
var playlist_add_check = 1;
var playlist_add_checkcircle = 1;
var playlist_add_circle = 1;
var playlist_play = 1;
var playlist_remove = 1;
var plumbing = 1;
var plus_one = 1;
var podcasts = 1;
var point_of_sale = 1;
var policy = 1;
var poll = 1;
var polyline = 1;
var pool = 1;
var portable_wifi_off = 1;
var portrait = 1;
var post_add = 1;
var power = 1;
var power_input = 1;
var power_off = 1;
var power_settings_new = 1;
var precision_manufacturing = 1;
var pregnant_woman = 1;
var present_to_all = 1;
var preview = 1;
var price_change = 1;
var price_check = 1;
var print = 1;
var print_disabled = 1;
var priority_high = 1;
var privacy_tip = 1;
var production_quantity_limits = 1;
var propane = 1;
var propane_tank = 1;
var psychology = 1;
var psychology_alt = 1;
var public_off = 1;
var publish = 1;
var published_with_changes = 1;
var punch_clock = 1;
var push_pin = 1;
var qr_code = 1;
var qr_code2 = 1;
var qr_code_scanner = 1;
var query_builder = 1;
var query_stats = 1;
var question_answer = 1;
var question_mark = 1;
var queue = 1;
var queue_music = 1;
var queue_play_next = 1;
var quickreply = 1;
var quiz = 1;
var r_mobiledata = 1;
var radar = 1;
var radio = 1;
var radio_button_checked = 1;
var radio_button_unchecked = 1;
var railway_alert = 1;
var ramen_dining = 1;
var ramp_left = 1;
var ramp_right = 1;
var rate_review = 1;
var raw_off = 1;
var raw_on = 1;
var read_more = 1;
var receipt = 1;
var receipt_long = 1;
var recent_actors = 1;
var recommend = 1;
var record_voice_over = 1;
var rectangle = 1;
var redeem = 1;
var redo = 1;
var reduce_capacity = 1;
var refresh = 1;
var remember_me = 1;
var remove = 1;
var remove_circle = 1;
var remove_circle_outline = 1;
var remove_done = 1;
var remove_from_queue = 1;
var remove_moderator = 1;
var remove_red_eye = 1;
var remove_road = 1;
var remove_shopping_cart = 1;
var reorder = 1;
var repartition = 1;
var repeat = 1;
var repeat_on = 1;
var repeat_one = 1;
var repeat_one_on = 1;
var replay = 1;
var replay10 = 1;
var replay30 = 1;
var replay5 = 1;
var replay_circle_filled = 1;
var reply = 1;
var reply_all = 1;
var report = 1;
var report_gmailerrorred = 1;
var report_off = 1;
var report_problem = 1;
var request_page = 1;
var request_quote = 1;
var reset_tv = 1;
var restart_alt = 1;
var restaurant = 1;
var restaurant_menu = 1;
var restore = 1;
var restore_from_trash = 1;
var restore_page = 1;
var reviews = 1;
var rice_bowl = 1;
var ring_volume = 1;
var rocket = 1;
var rocket_launch = 1;
var roller_shades = 1;
var roller_shades_closed = 1;
var roller_skating = 1;
var roofing = 1;
var room = 1;
var room_preferences = 1;
var room_service = 1;
var rotate_90_degrees_ccw = 1;
var rotate_90_degrees_cw = 1;
var rotate_left = 1;
var rotate_right = 1;
var roundabout_left = 1;
var roundabout_right = 1;
var rounded_corner = 1;
var route = 1;
var router = 1;
var rowing = 1;
var rss_feed = 1;
var rsvp = 1;
var rtt = 1;
var rule = 1;
var rule_folder = 1;
var run_circle = 1;
var running_with_errors = 1;
var rv_hookup = 1;
var safety_check = 1;
var safety_divider = 1;
var sailing = 1;
var sanitizer = 1;
var satellite = 1;
var satellite_alt = 1;
var save = 1;
var save_alt = 1;
var save_as = 1;
var saved_search = 1;
var savings = 1;
var scale = 1;
var scanner = 1;
var scatter_plot = 1;
var schedule = 1;
var schedule_send = 1;
var schema = 1;
var school = 1;
var science = 1;
var score = 1;
var scoreboard = 1;
var screen_lock_landscape = 1;
var screen_lock_portrait = 1;
var screen_lock_rotation = 1;
var screen_rotation = 1;
var screen_rotation_alt = 1;
var screen_search_desktop = 1;
var screen_share = 1;
var screenshot = 1;
var screenshot_monitor = 1;
var scuba_diving = 1;
var sd = 1;
var sd_card = 1;
var sd_card_alert = 1;
var sd_storage = 1;
var search = 1;
var search_off = 1;
var security = 1;
var security_update = 1;
var security_update_good = 1;
var security_update_warning = 1;
var segment = 1;
var select_all = 1;
var self_improvement = 1;
var sell = 1;
var send = 1;
var send_and_archive = 1;
var send_time_extension = 1;
var send_to_mobile = 1;
var sensor_door = 1;
var sensor_occupied = 1;
var sensor_window = 1;
var sensors = 1;
var sensors_off = 1;
var sentiment_dissatisfied = 1;
var sentiment_neutral = 1;
var sentiment_satisfied = 1;
var sentiment_satisfied_alt = 1;
var sentiment_very_dissatisfied = 1;
var sentiment_very_satisfied = 1;
var set_meal = 1;
var settings = 1;
var settings_accessibility = 1;
var settings_applications = 1;
var settings_backup_restore = 1;
var settings_bluetooth = 1;
var settings_brightness = 1;
var settings_cell = 1;
var settings_ethernet = 1;
var settings_input_antenna = 1;
var settings_input_component = 1;
var settings_input_composite = 1;
var settings_input_hdmi = 1;
var settings_input_svideo = 1;
var settings_overscan = 1;
var settings_phone = 1;
var settings_power = 1;
var settings_remote = 1;
var settings_suggest = 1;
var settings_system_daydream = 1;
var settings_voice = 1;
var severe_cold = 1;
var shape_line = 1;
var share = 1;
var share_location = 1;
var shield = 1;
var shield_moon = 1;
var shop = 1;
var shop2 = 1;
var shop_two = 1;
var shopping_bag = 1;
var shopping_basket = 1;
var shopping_cart = 1;
var shopping_cart_checkout = 1;
var short_text = 1;
var shortcut = 1;
var show_chart = 1;
var shower = 1;
var shuffle = 1;
var shuffle_on = 1;
var shutter_speed = 1;
var sick = 1;
var sign_language = 1;
var signal_cellular_0_bar = 1;
var signal_cellular_4_bar = 1;
var signal_cellular_alt = 1;
var signal_cellular_alt1bar = 1;
var signal_cellular_alt2bar = 1;
var signal_cellular_connected_no_internet_0_bar = 1;
var signal_cellular_connected_no_internet_4_bar = 1;
var signal_cellular_no_sim = 1;
var signal_cellular_nodata = 1;
var signal_cellular_null = 1;
var signal_cellular_off = 1;
var signal_wifi_0_bar = 1;
var signal_wifi_4_bar = 1;
var signal_wifi_4_bar_lock = 1;
var signal_wifi_bad = 1;
var signal_wifi_connected_no_internet_4 = 1;
var signal_wifi_off = 1;
var signpost = 1;
var sim_card = 1;
var sim_card_alert = 1;
var sim_card_download = 1;
var single_bed = 1;
var sip = 1;
var skateboarding = 1;
var skip_next = 1;
var skip_previous = 1;
var sledding = 1;
var slideshow = 1;
var slow_motion_video = 1;
var smart_button = 1;
var smart_display = 1;
var smart_screen = 1;
var smart_toy = 1;
var smartphone = 1;
var smoke_free = 1;
var smoking_rooms = 1;
var sms = 1;
var sms_failed = 1;
var snippet_folder = 1;
var snooze = 1;
var snowboarding = 1;
var snowmobile = 1;
var snowshoeing = 1;
var soap = 1;
var social_distance = 1;
var solar_power = 1;
var sort = 1;
var sort_by_alpha = 1;
var sos = 1;
var soup_kitchen = 1;
var source = 1;
var south = 1;
var south_america = 1;
var south_east = 1;
var south_west = 1;
var spa = 1;
var space_bar = 1;
var spatial_audio = 1;
var spatial_audio_off = 1;
var spatial_tracking = 1;
var speaker = 1;
var speaker_group = 1;
var speaker_notes = 1;
var speaker_notes_off = 1;
var speaker_phone = 1;
var speed = 1;
var spellcheck = 1;
var splitscreen = 1;
var spoke = 1;
var sports = 1;
var sports_bar = 1;
var sports_baseball = 1;
var sports_basketball = 1;
var sports_cricket = 1;
var sports_esports = 1;
var sports_football = 1;
var sports_golf = 1;
var sports_gymnastics = 1;
var sports_handball = 1;
var sports_hockey = 1;
var sports_kabaddi = 1;
var sports_martial_arts = 1;
var sports_mma = 1;
var sports_motorsports = 1;
var sports_rugby = 1;
var sports_score = 1;
var sports_soccer = 1;
var sports_tennis = 1;
var sports_volleyball = 1;
var square = 1;
var square_foot = 1;
var ssid_chart = 1;
var stacked_bar_chart = 1;
var stacked_line_chart = 1;
var stadium = 1;
var stairs = 1;
var star = 1;
var star_border = 1;
var star_border_purple500 = 1;
var star_half = 1;
var star_outline = 1;
var star_purple500 = 1;
var star_rate = 1;
var stars = 1;
var start = 1;
var stay_current_landscape = 1;
var stay_current_portrait = 1;
var stay_primary_landscape = 1;
var stay_primary_portrait = 1;
var sticky_note_2 = 1;
var stop = 1;
var stop_circle = 1;
var stop_screen_share = 1;
var storage = 1;
var store = 1;
var store_mall_directory = 1;
var storefront = 1;
var storm = 1;
var straight = 1;
var straighten = 1;
var stream = 1;
var streetview = 1;
var strikethrough_s = 1;
var stroller = 1;
var style = 1;
var subdirectory_arrow_left = 1;
var subdirectory_arrow_right = 1;
var subject = 1;
var subscript = 1;
var subscriptions = 1;
var subtitles = 1;
var subtitles_off = 1;
var subway = 1;
var summarize = 1;
var superscript = 1;
var supervised_user_circle = 1;
var supervisor_account = 1;
var support = 1;
var support_agent = 1;
var surfing = 1;
var surround_sound = 1;
var swap_calls = 1;
var swap_horiz = 1;
var swap_horizontal_circle = 1;
var swap_vert = 1;
var swap_vertical_circle = 1;
var swipe = 1;
var swipe_down = 1;
var swipe_down_alt = 1;
var swipe_left = 1;
var swipe_left_alt = 1;
var swipe_right = 1;
var swipe_right_alt = 1;
var swipe_up = 1;
var swipe_up_alt = 1;
var swipe_vertical = 1;
var switch_access_shortcut = 1;
var switch_access_shortcutadd = 1;
var switch_account = 1;
var switch_camera = 1;
var switch_left = 1;
var switch_right = 1;
var switch_video = 1;
var synagogue = 1;
var sync = 1;
var sync_alt = 1;
var sync_disabled = 1;
var sync_lock = 1;
var sync_problem = 1;
var system_security_update = 1;
var system_security_updategood = 1;
var system_security_updatewarning = 1;
var system_update = 1;
var system_update_alt = 1;
var tab = 1;
var tab_unselected = 1;
var table_bar = 1;
var table_chart = 1;
var table_restaurant = 1;
var table_rows = 1;
var table_view = 1;
var tablet = 1;
var tablet_android = 1;
var tablet_mac = 1;
var tag = 1;
var tag_faces = 1;
var takeout_dining = 1;
var tap_and_play = 1;
var tapas = 1;
var task = 1;
var task_alt = 1;
var taxi_alert = 1;
var temple_buddhist = 1;
var temple_hindu = 1;
var terminal = 1;
var terrain = 1;
var text_decrease = 1;
var text_fields = 1;
var text_format = 1;
var text_increase = 1;
var text_rotate_up = 1;
var text_rotate_vertical = 1;
var text_rotation_angledown = 1;
var text_rotation_angleup = 1;
var text_rotation_down = 1;
var text_rotation_none = 1;
var text_snippet = 1;
var textsms = 1;
var texture = 1;
var theater_comedy = 1;
var theaters = 1;
var thermostat = 1;
var thermostat_auto = 1;
var thumb_down = 1;
var thumb_down_alt = 1;
var thumb_down_offalt = 1;
var thumb_up = 1;
var thumb_up_alt = 1;
var thumb_up_offalt = 1;
var thumbs_up_down = 1;
var thunderstorm = 1;
var time_to_leave = 1;
var timelapse = 1;
var timeline = 1;
var timer = 1;
var timer10 = 1;
var timer10_select = 1;
var timer3 = 1;
var timer3_select = 1;
var timer_off = 1;
var tips_and_updates = 1;
var tire_repair = 1;
var title = 1;
var toc = 1;
var today = 1;
var toggle_off = 1;
var toggle_on = 1;
var token = 1;
var toll = 1;
var tonality = 1;
var topic = 1;
var tornado = 1;
var touch_app = 1;
var tour = 1;
var toys = 1;
var track_changes = 1;
var traffic = 1;
var train = 1;
var tram = 1;
var transcribe = 1;
var transfer_within_a_station = 1;
var transform = 1;
var transgender = 1;
var transit_enterexit = 1;
var translate = 1;
var travel_explore = 1;
var trending_down = 1;
var trending_flat = 1;
var trending_up = 1;
var trip_origin = 1;
var troubleshoot = 1;
var tsunami = 1;
var tty = 1;
var tune = 1;
var tungsten = 1;
var turn_left = 1;
var turn_right = 1;
var turn_sharp_left = 1;
var turn_sharp_right = 1;
var turn_slight_left = 1;
var turn_slight_right = 1;
var turned_in = 1;
var turned_in_not = 1;
var tv = 1;
var tv_off = 1;
var two_wheeler = 1;
var type_specimen = 1;
var u_turn_left = 1;
var u_turn_right = 1;
var umbrella = 1;
var unarchive = 1;
var undo = 1;
var unfold_less = 1;
var unfold_less_double = 1;
var unfold_more = 1;
var unfold_more_double = 1;
var unpublished = 1;
var unsubscribe = 1;
var upcoming = 1;
var update = 1;
var update_disabled = 1;
var upgrade = 1;
var upload = 1;
var upload_file = 1;
var usb = 1;
var usb_off = 1;
var vaccines = 1;
var vape_free = 1;
var vaping_rooms = 1;
var verified = 1;
var verified_user = 1;
var vertical_align_bottom = 1;
var vertical_align_center = 1;
var vertical_align_top = 1;
var vertical_shades = 1;
var vertical_shades_closed = 1;
var vertical_split = 1;
var vibration = 1;
var video_call = 1;
var video_camera_back = 1;
var video_camera_front = 1;
var video_chat = 1;
var video_file = 1;
var video_label = 1;
var video_library = 1;
var video_settings = 1;
var video_stable = 1;
var videocam = 1;
var videocam_off = 1;
var videogame_asset = 1;
var videogame_asset_off = 1;
var view_agenda = 1;
var view_array = 1;
var view_carousel = 1;
var view_column = 1;
var view_comfy = 1;
var view_comfy_alt = 1;
var view_compact = 1;
var view_compact_alt = 1;
var view_cozy = 1;
var view_day = 1;
var view_headline = 1;
var view_in_ar = 1;
var view_kanban = 1;
var view_list = 1;
var view_module = 1;
var view_quilt = 1;
var view_sidebar = 1;
var view_stream = 1;
var view_timeline = 1;
var view_week = 1;
var vignette = 1;
var villa = 1;
var visibility = 1;
var visibility_off = 1;
var voice_chat = 1;
var voice_over_off = 1;
var voicemail = 1;
var volcano = 1;
var volume_down = 1;
var volume_mute = 1;
var volume_off = 1;
var volume_up = 1;
var volunteer_activism = 1;
var vpn_key = 1;
var vpn_key_off = 1;
var vpn_lock = 1;
var vrpano = 1;
var wallet = 1;
var wallpaper = 1;
var warehouse = 1;
var warning = 1;
var warning_amber = 1;
var wash = 1;
var watch = 1;
var watch_later = 1;
var watch_off = 1;
var water = 1;
var water_damage = 1;
var waterfall_chart = 1;
var waves = 1;
var wb_auto = 1;
var wb_cloudy = 1;
var wb_incandescent = 1;
var wb_iridescent = 1;
var wb_shade = 1;
var wb_sunny = 1;
var wb_twilight = 1;
var wc = 1;
var web = 1;
var web_asset = 1;
var web_asset_off = 1;
var web_stories = 1;
var webhook = 1;
var weekend = 1;
var west = 1;
var whatshot = 1;
var wheelchair_pickup = 1;
var where_to_vote = 1;
var widgets = 1;
var width_full = 1;
var width_normal = 1;
var width_wide = 1;
var wifi = 1;
var wifi1_bar = 1;
var wifi2_bar = 1;
var wifi_calling = 1;
var wifi_calling3 = 1;
var wifi_channel = 1;
var wifi_find = 1;
var wifi_lock = 1;
var wifi_off = 1;
var wifi_password = 1;
var wifi_protected_setup = 1;
var wifi_tethering = 1;
var wifi_tethering_error = 1;
var wifi_tethering_errorrounded = 1;
var wifi_tethering_off = 1;
var wind_power = 1;
var window$1 = 1;
var wine_bar = 1;
var woman = 1;
var woman2 = 1;
var work = 1;
var work_history = 1;
var work_off = 1;
var work_outline = 1;
var workspace_premium = 1;
var workspaces = 1;
var wrap_text = 1;
var wrong_location = 1;
var wysiwyg = 1;
var yard = 1;
var youtube_searched_for = 1;
var zoom_in = 1;
var zoom_in_map = 1;
var zoom_out = 1;
var zoom_out_map = 1;
var allowedIcons = {
	"360": 1,
	"10mp": 1,
	"11mp": 1,
	"12mp": 1,
	"13mp": 1,
	"14mp": 1,
	"15mp": 1,
	"16mp": 1,
	"17mp": 1,
	"18_up_rating": 1,
	"18mp": 1,
	"19mp": 1,
	"1k": 1,
	"1k_plus": 1,
	"1kk": 1,
	"1x_mobiledata": 1,
	"20mp": 1,
	"21mp": 1,
	"22mp": 1,
	"23mp": 1,
	"24mp": 1,
	"2k": 1,
	"2k_plus": 1,
	"2mp": 1,
	"30fps": 1,
	"30fps_select": 1,
	"3d_rotation": 1,
	"3g_mobiledata": 1,
	"3k": 1,
	"3k_plus": 1,
	"3mp": 1,
	"3p": 1,
	"4g_mobiledata": 1,
	"4g_plus_mobiledata": 1,
	"4k": 1,
	"4k_plus": 1,
	"4mp": 1,
	"5g": 1,
	"5k": 1,
	"5k_plus": 1,
	"5mp": 1,
	"60fps": 1,
	"60fps_select": 1,
	"6k": 1,
	"6k_plus": 1,
	"6mp": 1,
	"7k": 1,
	"7k_plus": 1,
	"7mp": 1,
	"8k": 1,
	"8k_plus": 1,
	"8mp": 1,
	"9k": 1,
	"9k_plus": 1,
	"9mp": 1,
	abc: abc,
	ac_unit: ac_unit,
	access_alarm: access_alarm,
	access_alarms: access_alarms,
	access_time: access_time,
	access_time_filled: access_time_filled,
	accessibility: accessibility,
	accessibility_new: accessibility_new,
	accessible: accessible,
	accessible_forward: accessible_forward,
	account_balance: account_balance,
	account_balance_wallet: account_balance_wallet,
	account_box: account_box,
	account_circle: account_circle,
	account_tree: account_tree,
	ad_units: ad_units,
	adb: adb,
	add: add,
	add_a_photo: add_a_photo,
	add_alarm: add_alarm,
	add_alert: add_alert,
	add_box: add_box,
	add_business: add_business,
	add_card: add_card,
	add_circle: add_circle,
	add_circle_outline: add_circle_outline,
	add_comment: add_comment,
	add_home: add_home,
	add_home_work: add_home_work,
	add_ic_call: add_ic_call,
	add_link: add_link,
	add_location: add_location,
	add_location_alt: add_location_alt,
	add_moderator: add_moderator,
	add_photo_alternate: add_photo_alternate,
	add_reaction: add_reaction,
	add_road: add_road,
	add_shopping_cart: add_shopping_cart,
	add_task: add_task,
	add_to_drive: add_to_drive,
	add_to_homescreen: add_to_homescreen,
	add_to_photos: add_to_photos,
	add_to_queue: add_to_queue,
	addchart: addchart,
	adf_scanner: adf_scanner,
	adjust: adjust,
	admin_panel_settings: admin_panel_settings,
	agriculture: agriculture,
	air: air,
	airline_seat_flat: airline_seat_flat,
	airline_seat_flatangled: airline_seat_flatangled,
	airline_seat_individualsuite: airline_seat_individualsuite,
	airline_seat_legroomextra: airline_seat_legroomextra,
	airline_seat_legroomnormal: airline_seat_legroomnormal,
	airline_seat_legroomreduced: airline_seat_legroomreduced,
	airline_seat_reclineextra: airline_seat_reclineextra,
	airline_seat_reclinenormal: airline_seat_reclinenormal,
	airline_stops: airline_stops,
	airlines: airlines,
	airplane_ticket: airplane_ticket,
	airplanemode_active: airplanemode_active,
	airplanemode_inactive: airplanemode_inactive,
	airplay: airplay,
	airport_shuttle: airport_shuttle,
	alarm: alarm,
	alarm_add: alarm_add,
	alarm_off: alarm_off,
	alarm_on: alarm_on,
	album: album,
	align_horizontal_center: align_horizontal_center,
	align_horizontal_left: align_horizontal_left,
	align_horizontal_right: align_horizontal_right,
	align_vertical_bottom: align_vertical_bottom,
	align_vertical_center: align_vertical_center,
	align_vertical_top: align_vertical_top,
	all_inbox: all_inbox,
	all_inclusive: all_inclusive,
	all_out: all_out,
	alt_route: alt_route,
	alternate_email: alternate_email,
	analytics: analytics,
	anchor: anchor,
	android: android,
	animation: animation,
	announcement: announcement,
	aod: aod,
	apartment: apartment,
	api: api,
	app_blocking: app_blocking,
	app_registration: app_registration,
	app_settings_alt: app_settings_alt,
	app_shortcut: app_shortcut,
	approval: approval,
	apps: apps,
	apps_outage: apps_outage,
	architecture: architecture,
	archive: archive,
	arrow_back: arrow_back,
	arrow_back_ios: arrow_back_ios,
	arrow_back_iosnew: arrow_back_iosnew,
	arrow_circle_down: arrow_circle_down,
	arrow_circle_left: arrow_circle_left,
	arrow_circle_right: arrow_circle_right,
	arrow_circle_up: arrow_circle_up,
	arrow_downward: arrow_downward,
	arrow_drop_down: arrow_drop_down,
	arrow_drop_downcircle: arrow_drop_downcircle,
	arrow_drop_up: arrow_drop_up,
	arrow_forward: arrow_forward,
	arrow_forward_ios: arrow_forward_ios,
	arrow_left: arrow_left,
	arrow_outward: arrow_outward,
	arrow_right: arrow_right,
	arrow_right_alt: arrow_right_alt,
	arrow_upward: arrow_upward,
	art_track: art_track,
	article: article,
	aspect_ratio: aspect_ratio,
	assessment: assessment,
	assignment: assignment,
	assignment_ind: assignment_ind,
	assignment_late: assignment_late,
	assignment_return: assignment_return,
	assignment_returned: assignment_returned,
	assignment_turned_in: assignment_turned_in,
	assist_walker: assist_walker,
	assistant: assistant,
	assistant_direction: assistant_direction,
	assistant_photo: assistant_photo,
	assured_workload: assured_workload,
	atm: atm,
	attach_email: attach_email,
	attach_file: attach_file,
	attach_money: attach_money,
	attachment: attachment,
	attractions: attractions,
	attribution: attribution,
	audio_file: audio_file,
	audiotrack: audiotrack,
	auto_awesome: auto_awesome,
	auto_awesome_mosaic: auto_awesome_mosaic,
	auto_awesome_motion: auto_awesome_motion,
	auto_delete: auto_delete,
	auto_fix_high: auto_fix_high,
	auto_fix_normal: auto_fix_normal,
	auto_fix_off: auto_fix_off,
	auto_graph: auto_graph,
	auto_mode: auto_mode,
	auto_stories: auto_stories,
	autofps_select: autofps_select,
	autorenew: autorenew,
	av_timer: av_timer,
	baby_changing_station: baby_changing_station,
	backpack: backpack,
	backspace: backspace,
	backup: backup,
	backup_table: backup_table,
	badge: badge,
	bakery_dining: bakery_dining,
	balance: balance,
	balcony: balcony,
	ballot: ballot,
	bar_chart: bar_chart,
	batch_prediction: batch_prediction,
	bathroom: bathroom,
	bathtub: bathtub,
	battery_0_bar: battery_0_bar,
	battery_1_bar: battery_1_bar,
	battery_2_bar: battery_2_bar,
	battery_3_bar: battery_3_bar,
	battery_4_bar: battery_4_bar,
	battery_5_bar: battery_5_bar,
	battery_6_bar: battery_6_bar,
	battery_alert: battery_alert,
	battery_charging_full: battery_charging_full,
	battery_full: battery_full,
	battery_saver: battery_saver,
	battery_std: battery_std,
	battery_unknown: battery_unknown,
	beach_access: beach_access,
	bed: bed,
	bedroom_baby: bedroom_baby,
	bedroom_child: bedroom_child,
	bedroom_parent: bedroom_parent,
	bedtime: bedtime,
	bedtime_off: bedtime_off,
	beenhere: beenhere,
	bento: bento,
	bike_scooter: bike_scooter,
	biotech: biotech,
	blender: blender,
	blind: blind,
	blinds: blinds,
	blinds_closed: blinds_closed,
	block: block,
	bloodtype: bloodtype,
	bluetooth: bluetooth,
	bluetooth_audio: bluetooth_audio,
	bluetooth_connected: bluetooth_connected,
	bluetooth_disabled: bluetooth_disabled,
	bluetooth_drive: bluetooth_drive,
	bluetooth_searching: bluetooth_searching,
	blur_circular: blur_circular,
	blur_linear: blur_linear,
	blur_off: blur_off,
	blur_on: blur_on,
	bolt: bolt,
	book: book,
	book_online: book_online,
	bookmark: bookmark,
	bookmark_add: bookmark_add,
	bookmark_added: bookmark_added,
	bookmark_border: bookmark_border,
	bookmark_remove: bookmark_remove,
	bookmarks: bookmarks,
	border_all: border_all,
	border_bottom: border_bottom,
	border_clear: border_clear,
	border_color: border_color,
	border_horizontal: border_horizontal,
	border_inner: border_inner,
	border_left: border_left,
	border_outer: border_outer,
	border_right: border_right,
	border_style: border_style,
	border_top: border_top,
	border_vertical: border_vertical,
	boy: boy,
	branding_watermark: branding_watermark,
	breakfast_dining: breakfast_dining,
	brightness_1: brightness_1,
	brightness_2: brightness_2,
	brightness_3: brightness_3,
	brightness_4: brightness_4,
	brightness_5: brightness_5,
	brightness_6: brightness_6,
	brightness_7: brightness_7,
	brightness_auto: brightness_auto,
	brightness_high: brightness_high,
	brightness_low: brightness_low,
	brightness_medium: brightness_medium,
	broadcast_on_home: broadcast_on_home,
	broadcast_on_personal: broadcast_on_personal,
	broken_image: broken_image,
	browse_gallery: browse_gallery,
	browser_not_supported: browser_not_supported,
	browser_updated: browser_updated,
	brunch_dining: brunch_dining,
	brush: brush,
	bubble_chart: bubble_chart,
	bug_report: bug_report,
	build: build,
	build_circle: build_circle,
	bungalow: bungalow,
	burst_mode: burst_mode,
	bus_alert: bus_alert,
	business: business,
	business_center: business_center,
	cabin: cabin,
	cable: cable,
	cached: cached,
	cake: cake,
	calculate: calculate,
	calendar_month: calendar_month,
	calendar_today: calendar_today,
	calendar_view_day: calendar_view_day,
	calendar_view_month: calendar_view_month,
	calendar_view_week: calendar_view_week,
	call: call,
	call_end: call_end,
	call_made: call_made,
	call_merge: call_merge,
	call_missed: call_missed,
	call_missed_outgoing: call_missed_outgoing,
	call_received: call_received,
	call_split: call_split,
	call_to_action: call_to_action,
	camera: camera,
	camera_alt: camera_alt,
	camera_enhance: camera_enhance,
	camera_front: camera_front,
	camera_indoor: camera_indoor,
	camera_outdoor: camera_outdoor,
	camera_rear: camera_rear,
	camera_roll: camera_roll,
	cameraswitch: cameraswitch,
	campaign: campaign,
	cancel: cancel,
	cancel_presentation: cancel_presentation,
	cancel_schedule_send: cancel_schedule_send,
	candlestick_chart: candlestick_chart,
	car_crash: car_crash,
	car_rental: car_rental,
	car_repair: car_repair,
	card_giftcard: card_giftcard,
	card_membership: card_membership,
	card_travel: card_travel,
	carpenter: carpenter,
	cases: cases,
	casino: casino,
	cast: cast,
	cast_connected: cast_connected,
	cast_for_education: cast_for_education,
	castle: castle,
	catching_pokemon: catching_pokemon,
	category: category,
	celebration: celebration,
	cell_tower: cell_tower,
	cell_wifi: cell_wifi,
	center_focus_strong: center_focus_strong,
	center_focus_weak: center_focus_weak,
	chair: chair,
	chair_alt: chair_alt,
	chalet: chalet,
	change_circle: change_circle,
	change_history: change_history,
	charging_station: charging_station,
	chat: chat,
	chat_bubble: chat_bubble,
	chat_bubble_outline: chat_bubble_outline,
	check: check,
	check_box: check_box,
	check_box_outlineblank: check_box_outlineblank,
	check_circle: check_circle,
	check_circle_outline: check_circle_outline,
	checkroom: checkroom,
	chevron_left: chevron_left,
	chevron_right: chevron_right,
	child_care: child_care,
	child_friendly: child_friendly,
	chrome_reader_mode: chrome_reader_mode,
	church: church,
	circle: circle,
	circle_notifications: circle_notifications,
	"class": 1,
	clean_hands: clean_hands,
	cleaning_services: cleaning_services,
	clear: clear,
	clear_all: clear_all,
	close: close,
	close_fullscreen: close_fullscreen,
	closed_caption: closed_caption,
	closed_caption_disabled: closed_caption_disabled,
	closed_caption_off: closed_caption_off,
	cloud: cloud,
	cloud_circle: cloud_circle,
	cloud_done: cloud_done,
	cloud_download: cloud_download,
	cloud_off: cloud_off,
	cloud_queue: cloud_queue,
	cloud_sync: cloud_sync,
	cloud_upload: cloud_upload,
	co2: co2,
	co_present: co_present,
	code: code,
	code_off: code_off,
	coffee: coffee,
	coffee_maker: coffee_maker,
	collections: collections,
	collections_bookmark: collections_bookmark,
	color_lens: color_lens,
	colorize: colorize,
	comment: comment,
	comment_bank: comment_bank,
	comments_disabled: comments_disabled,
	commit: commit,
	commute: commute,
	compare: compare,
	compare_arrows: compare_arrows,
	compass_calibration: compass_calibration,
	compress: compress,
	computer: computer,
	confirmation_number: confirmation_number,
	connect_without_contact: connect_without_contact,
	connected_tv: connected_tv,
	connecting_airports: connecting_airports,
	construction: construction,
	contact_emergency: contact_emergency,
	contact_mail: contact_mail,
	contact_page: contact_page,
	contact_phone: contact_phone,
	contact_support: contact_support,
	contactless: contactless,
	contacts: contacts,
	content_copy: content_copy,
	content_cut: content_cut,
	content_paste: content_paste,
	content_paste_go: content_paste_go,
	content_paste_off: content_paste_off,
	content_paste_search: content_paste_search,
	contrast: contrast,
	control_camera: control_camera,
	control_point: control_point,
	control_point_duplicate: control_point_duplicate,
	cookie: cookie,
	copy_all: copy_all,
	copyright: copyright,
	coronavirus: coronavirus,
	corporate_fare: corporate_fare,
	cottage: cottage,
	countertops: countertops,
	create: create,
	create_new_folder: create_new_folder,
	credit_card: credit_card,
	credit_card_off: credit_card_off,
	credit_score: credit_score,
	crib: crib,
	crisis_alert: crisis_alert,
	crop: crop,
	crop169: crop169,
	crop32: crop32,
	crop54: crop54,
	crop75: crop75,
	crop_din: crop_din,
	crop_free: crop_free,
	crop_landscape: crop_landscape,
	crop_original: crop_original,
	crop_portrait: crop_portrait,
	crop_rotate: crop_rotate,
	crop_square: crop_square,
	css: css,
	currency_bitcoin: currency_bitcoin,
	currency_exchange: currency_exchange,
	currency_franc: currency_franc,
	currency_lira: currency_lira,
	currency_pound: currency_pound,
	currency_ruble: currency_ruble,
	currency_rupee: currency_rupee,
	currency_yen: currency_yen,
	currency_yuan: currency_yuan,
	curtains: curtains,
	curtains_closed: curtains_closed,
	cyclone: cyclone,
	dangerous: dangerous,
	dark_mode: dark_mode,
	dashboard: dashboard,
	dashboard_customize: dashboard_customize,
	data_array: data_array,
	data_object: data_object,
	data_saver_off: data_saver_off,
	data_saver_on: data_saver_on,
	data_thresholding: data_thresholding,
	data_usage: data_usage,
	dataset: dataset,
	dataset_linked: dataset_linked,
	date_range: date_range,
	deblur: deblur,
	deck: deck,
	dehaze: dehaze,
	"delete": 1,
	delete_forever: delete_forever,
	delete_outline: delete_outline,
	delete_sweep: delete_sweep,
	delivery_dining: delivery_dining,
	density_large: density_large,
	density_medium: density_medium,
	density_small: density_small,
	departure_board: departure_board,
	description: description,
	deselect: deselect,
	design_services: design_services,
	desk: desk,
	desktop_access_disabled: desktop_access_disabled,
	desktop_mac: desktop_mac,
	desktop_windows: desktop_windows,
	details: details,
	developer_board: developer_board,
	developer_board_off: developer_board_off,
	developer_mode: developer_mode,
	device_hub: device_hub,
	device_thermostat: device_thermostat,
	device_unknown: device_unknown,
	devices: devices,
	devices_fold: devices_fold,
	devices_other: devices_other,
	dialer_sip: dialer_sip,
	dialpad: dialpad,
	diamond: diamond,
	difference: difference,
	dining: dining,
	dinner_dining: dinner_dining,
	directions: directions,
	directions_bike: directions_bike,
	directions_boat: directions_boat,
	directions_boat_filled: directions_boat_filled,
	directions_bus: directions_bus,
	directions_bus_filled: directions_bus_filled,
	directions_car: directions_car,
	directions_car_filled: directions_car_filled,
	directions_off: directions_off,
	directions_railway: directions_railway,
	directions_railway_filled: directions_railway_filled,
	directions_run: directions_run,
	directions_subway: directions_subway,
	directions_subway_filled: directions_subway_filled,
	directions_transit: directions_transit,
	directions_transit_filled: directions_transit_filled,
	directions_walk: directions_walk,
	dirty_lens: dirty_lens,
	disabled_by_default: disabled_by_default,
	disc_full: disc_full,
	discount: discount,
	display_settings: display_settings,
	diversity_1: diversity_1,
	diversity_2: diversity_2,
	diversity_3: diversity_3,
	dns: dns,
	do_disturb: do_disturb,
	do_disturb_alt: do_disturb_alt,
	do_disturb_off: do_disturb_off,
	do_disturb_on: do_disturb_on,
	do_not_disturb: do_not_disturb,
	do_not_disturbalt: do_not_disturbalt,
	do_not_disturboff: do_not_disturboff,
	do_not_disturbon: do_not_disturbon,
	do_not_disturbontotalsilence: do_not_disturbontotalsilence,
	do_not_step: do_not_step,
	do_not_touch: do_not_touch,
	dock: dock,
	document_scanner: document_scanner,
	domain: domain,
	domain_add: domain_add,
	domain_disabled: domain_disabled,
	domain_verification: domain_verification,
	done: done,
	done_all: done_all,
	done_outline: done_outline,
	donut_large: donut_large,
	donut_small: donut_small,
	door_back: door_back,
	door_front: door_front,
	door_sliding: door_sliding,
	doorbell: doorbell,
	double_arrow: double_arrow,
	downhill_skiing: downhill_skiing,
	download: download,
	download_done: download_done,
	download_for_offline: download_for_offline,
	downloading: downloading,
	drafts: drafts,
	drag_handle: drag_handle,
	drag_indicator: drag_indicator,
	drive_eta: drive_eta,
	drive_file_move: drive_file_move,
	drive_file_rename_outline: drive_file_rename_outline,
	drive_folder_upload: drive_folder_upload,
	dry: dry,
	dry_cleaning: dry_cleaning,
	duo: duo,
	dvr: dvr,
	dynamic_feed: dynamic_feed,
	dynamic_form: dynamic_form,
	e_mobiledata: e_mobiledata,
	earbuds: earbuds,
	earbuds_battery: earbuds_battery,
	east: east,
	edgesensor_high: edgesensor_high,
	edgesensor_low: edgesensor_low,
	edit: edit,
	edit_attributes: edit_attributes,
	edit_location: edit_location,
	edit_location_alt: edit_location_alt,
	edit_notifications: edit_notifications,
	edit_off: edit_off,
	edit_road: edit_road,
	egg: egg,
	egg_alt: egg_alt,
	eject: eject,
	elderly: elderly,
	elderly_woman: elderly_woman,
	electric_bike: electric_bike,
	electric_bolt: electric_bolt,
	electric_car: electric_car,
	electric_meter: electric_meter,
	electric_moped: electric_moped,
	electric_rickshaw: electric_rickshaw,
	electric_scooter: electric_scooter,
	electrical_services: electrical_services,
	elevator: elevator,
	email: email,
	emergency_recording: emergency_recording,
	emergency_share: emergency_share,
	emoji_emotions: emoji_emotions,
	emoji_events: emoji_events,
	emoji_flags: emoji_flags,
	emoji_food_beverage: emoji_food_beverage,
	emoji_nature: emoji_nature,
	emoji_objects: emoji_objects,
	emoji_people: emoji_people,
	emoji_symbols: emoji_symbols,
	emoji_transportation: emoji_transportation,
	energy_savings_leaf: energy_savings_leaf,
	engineering: engineering,
	enhanced_encryption: enhanced_encryption,
	equalizer: equalizer,
	error: error,
	error_outline: error_outline,
	escalator: escalator,
	escalator_warning: escalator_warning,
	euro: euro,
	euro_symbol: euro_symbol,
	ev_station: ev_station,
	event: event,
	event_available: event_available,
	event_busy: event_busy,
	event_note: event_note,
	event_repeat: event_repeat,
	event_seat: event_seat,
	exit_to_app: exit_to_app,
	expand: expand,
	expand_circle_down: expand_circle_down,
	expand_less: expand_less,
	expand_more: expand_more,
	explicit: explicit,
	explore: explore,
	explore_off: explore_off,
	exposure: exposure,
	extension: extension,
	extension_off: extension_off,
	face: face,
	face2: face2,
	face3: face3,
	face4: face4,
	face5: face5,
	face6: face6,
	face_retouching_natural: face_retouching_natural,
	face_retouching_off: face_retouching_off,
	facebook: facebook,
	fact_check: fact_check,
	factory: factory,
	family_restroom: family_restroom,
	fast_forward: fast_forward,
	fast_rewind: fast_rewind,
	fastfood: fastfood,
	favorite: favorite,
	favorite_border: favorite_border,
	fax: fax,
	featured_play_list: featured_play_list,
	featured_video: featured_video,
	feed: feed,
	feedback: feedback,
	female: female,
	fence: fence,
	festival: festival,
	fiber_dvr: fiber_dvr,
	fiber_manual_record: fiber_manual_record,
	fiber_new: fiber_new,
	fiber_pin: fiber_pin,
	fiber_smart_record: fiber_smart_record,
	file_copy: file_copy,
	file_download: file_download,
	file_download_done: file_download_done,
	file_download_off: file_download_off,
	file_open: file_open,
	file_present: file_present,
	file_upload: file_upload,
	filter: filter,
	filter1: filter1,
	filter2: filter2,
	filter3: filter3,
	filter4: filter4,
	filter5: filter5,
	filter6: filter6,
	filter7: filter7,
	filter8: filter8,
	filter9: filter9,
	filter9_plus: filter9_plus,
	filter_alt: filter_alt,
	filter_alt_off: filter_alt_off,
	filter_b_andw: filter_b_andw,
	filter_center_focus: filter_center_focus,
	filter_drama: filter_drama,
	filter_frames: filter_frames,
	filter_hdr: filter_hdr,
	filter_list: filter_list,
	filter_list_off: filter_list_off,
	filter_none: filter_none,
	filter_tilt_shift: filter_tilt_shift,
	filter_vintage: filter_vintage,
	find_in_page: find_in_page,
	find_replace: find_replace,
	fingerprint: fingerprint,
	fire_extinguisher: fire_extinguisher,
	fire_hydrant_alt: fire_hydrant_alt,
	fire_truck: fire_truck,
	fireplace: fireplace,
	first_page: first_page,
	fit_screen: fit_screen,
	fitbit: fitbit,
	fitness_center: fitness_center,
	flag: flag,
	flag_circle: flag_circle,
	flaky: flaky,
	flare: flare,
	flash_auto: flash_auto,
	flash_off: flash_off,
	flash_on: flash_on,
	flashlight_off: flashlight_off,
	flashlight_on: flashlight_on,
	flatware: flatware,
	flight: flight,
	flight_class: flight_class,
	flight_land: flight_land,
	flight_takeoff: flight_takeoff,
	flip: flip,
	flip_camera_android: flip_camera_android,
	flip_camera_ios: flip_camera_ios,
	flip_to_back: flip_to_back,
	flip_to_front: flip_to_front,
	flood: flood,
	fluorescent: fluorescent,
	flutter_dash: flutter_dash,
	fmd_bad: fmd_bad,
	fmd_good: fmd_good,
	folder: folder,
	folder_copy: folder_copy,
	folder_delete: folder_delete,
	folder_off: folder_off,
	folder_open: folder_open,
	folder_shared: folder_shared,
	folder_special: folder_special,
	folder_zip: folder_zip,
	follow_the_signs: follow_the_signs,
	font_download: font_download,
	font_download_off: font_download_off,
	food_bank: food_bank,
	forest: forest,
	fork_left: fork_left,
	fork_right: fork_right,
	format_align_center: format_align_center,
	format_align_justify: format_align_justify,
	format_align_left: format_align_left,
	format_align_right: format_align_right,
	format_bold: format_bold,
	format_clear: format_clear,
	format_color_fill: format_color_fill,
	format_color_reset: format_color_reset,
	format_color_text: format_color_text,
	format_indent_decrease: format_indent_decrease,
	format_indent_increase: format_indent_increase,
	format_italic: format_italic,
	format_line_spacing: format_line_spacing,
	format_list_bulleted: format_list_bulleted,
	format_list_numbered: format_list_numbered,
	format_list_numberedrtl: format_list_numberedrtl,
	format_overline: format_overline,
	format_paint: format_paint,
	format_quote: format_quote,
	format_shapes: format_shapes,
	format_size: format_size,
	format_strikethrough: format_strikethrough,
	format_textdirection_l_to_r: format_textdirection_l_to_r,
	format_textdirection_r_to_l: format_textdirection_r_to_l,
	format_underlined: format_underlined,
	fort: fort,
	forum: forum,
	forward: forward,
	forward10: forward10,
	forward30: forward30,
	forward5: forward5,
	forward_to_inbox: forward_to_inbox,
	foundation: foundation,
	free_breakfast: free_breakfast,
	fullscreen: fullscreen,
	fullscreen_exit: fullscreen_exit,
	functions: functions,
	g_mobiledata: g_mobiledata,
	g_translate: g_translate,
	gamepad: gamepad,
	games: games,
	garage: garage,
	gas_meter: gas_meter,
	gavel: gavel,
	gesture: gesture,
	get_app: get_app,
	gif: gif,
	gif_box: gif_box,
	girl: girl,
	gite: gite,
	golf_course: golf_course,
	gpp_bad: gpp_bad,
	gpp_good: gpp_good,
	gpp_maybe: gpp_maybe,
	gps_fixed: gps_fixed,
	gps_not_fixed: gps_not_fixed,
	gps_off: gps_off,
	grade: grade,
	gradient: gradient,
	grading: grading,
	grain: grain,
	graphic_eq: graphic_eq,
	grass: grass,
	grid_3x3: grid_3x3,
	grid_4x4: grid_4x4,
	grid_goldenratio: grid_goldenratio,
	grid_off: grid_off,
	grid_on: grid_on,
	grid_view: grid_view,
	group: group,
	group_add: group_add,
	group_remove: group_remove,
	group_work: group_work,
	groups: groups,
	groups2: groups2,
	groups3: groups3,
	h_mobiledata: h_mobiledata,
	h_plus_mobiledata: h_plus_mobiledata,
	hail: hail,
	handshake: handshake,
	handyman: handyman,
	hardware: hardware,
	hd: hd,
	hdr_auto: hdr_auto,
	hdr_auto_select: hdr_auto_select,
	hdr_enhanced_select: hdr_enhanced_select,
	hdr_off: hdr_off,
	hdr_off_select: hdr_off_select,
	hdr_on: hdr_on,
	hdr_on_select: hdr_on_select,
	hdr_plus: hdr_plus,
	hdr_strong: hdr_strong,
	hdr_weak: hdr_weak,
	headphones: headphones,
	headphones_battery: headphones_battery,
	headset: headset,
	headset_mic: headset_mic,
	headset_off: headset_off,
	healing: healing,
	health_and_safety: health_and_safety,
	hearing: hearing,
	hearing_disabled: hearing_disabled,
	heart_broken: heart_broken,
	heat_pump: heat_pump,
	height: height,
	help: help,
	help_center: help_center,
	help_outline: help_outline,
	hevc: hevc,
	hexagon: hexagon,
	hide_image: hide_image,
	hide_source: hide_source,
	high_quality: high_quality,
	highlight: highlight,
	highlight_alt: highlight_alt,
	highlight_off: highlight_off,
	hiking: hiking,
	history: history,
	history_edu: history_edu,
	history_toggle_off: history_toggle_off,
	hive: hive,
	hls: hls,
	hls_off: hls_off,
	holiday_village: holiday_village,
	home: home,
	home_max: home_max,
	home_mini: home_mini,
	home_repair_service: home_repair_service,
	home_work: home_work,
	horizontal_rule: horizontal_rule,
	horizontal_split: horizontal_split,
	hot_tub: hot_tub,
	hotel: hotel,
	hourglass_bottom: hourglass_bottom,
	hourglass_disabled: hourglass_disabled,
	hourglass_empty: hourglass_empty,
	hourglass_full: hourglass_full,
	hourglass_top: hourglass_top,
	house: house,
	house_siding: house_siding,
	houseboat: houseboat,
	how_to_reg: how_to_reg,
	how_to_vote: how_to_vote,
	html: html,
	http: http,
	https: https,
	hub: hub,
	hvac: hvac,
	ice_skating: ice_skating,
	icecream: icecream,
	image: image,
	image_aspect_ratio: image_aspect_ratio,
	image_not_supported: image_not_supported,
	image_search: image_search,
	imagesearch_roller: imagesearch_roller,
	import_contacts: import_contacts,
	import_export: import_export,
	important_devices: important_devices,
	inbox: inbox,
	indeterminate_check_box: indeterminate_check_box,
	info: info,
	input: input,
	insert_chart: insert_chart,
	insert_comment: insert_comment,
	insert_drive_file: insert_drive_file,
	insert_emoticon: insert_emoticon,
	insert_invitation: insert_invitation,
	insert_link: insert_link,
	insert_page_break: insert_page_break,
	insert_photo: insert_photo,
	insights: insights,
	install_desktop: install_desktop,
	install_mobile: install_mobile,
	integration_instructions: integration_instructions,
	interests: interests,
	interpreter_mode: interpreter_mode,
	inventory: inventory,
	inventory2: inventory2,
	invert_colors: invert_colors,
	invert_colors_off: invert_colors_off,
	ios_share: ios_share,
	iron: iron,
	iso: iso,
	javascript: javascript,
	join_full: join_full,
	join_inner: join_inner,
	join_left: join_left,
	join_right: join_right,
	kayaking: kayaking,
	kebab_dining: kebab_dining,
	key: key,
	key_off: key_off,
	keyboard: keyboard,
	keyboard_alt: keyboard_alt,
	keyboard_arrow_down: keyboard_arrow_down,
	keyboard_arrow_left: keyboard_arrow_left,
	keyboard_arrow_right: keyboard_arrow_right,
	keyboard_arrow_up: keyboard_arrow_up,
	keyboard_backspace: keyboard_backspace,
	keyboard_capslock: keyboard_capslock,
	keyboard_command_key: keyboard_command_key,
	keyboard_control_key: keyboard_control_key,
	keyboard_double_arrowdown: keyboard_double_arrowdown,
	keyboard_double_arrowleft: keyboard_double_arrowleft,
	keyboard_double_arrowright: keyboard_double_arrowright,
	keyboard_double_arrowup: keyboard_double_arrowup,
	keyboard_hide: keyboard_hide,
	keyboard_option_key: keyboard_option_key,
	keyboard_return: keyboard_return,
	keyboard_tab: keyboard_tab,
	keyboard_voice: keyboard_voice,
	king_bed: king_bed,
	kitchen: kitchen,
	kitesurfing: kitesurfing,
	label: label,
	label_important: label_important,
	label_off: label_off,
	lan: lan,
	landscape: landscape,
	landslide: landslide,
	language: language,
	laptop: laptop,
	laptop_chromebook: laptop_chromebook,
	laptop_mac: laptop_mac,
	laptop_windows: laptop_windows,
	last_page: last_page,
	launch: launch,
	layers: layers,
	layers_clear: layers_clear,
	leaderboard: leaderboard,
	leak_add: leak_add,
	leak_remove: leak_remove,
	legend_toggle: legend_toggle,
	lens: lens,
	lens_blur: lens_blur,
	library_add: library_add,
	library_add_check: library_add_check,
	library_books: library_books,
	library_music: library_music,
	light: light,
	light_mode: light_mode,
	lightbulb: lightbulb,
	lightbulb_circle: lightbulb_circle,
	line_axis: line_axis,
	line_style: line_style,
	line_weight: line_weight,
	linear_scale: linear_scale,
	link: link,
	link_off: link_off,
	linked_camera: linked_camera,
	liquor: liquor,
	list: list,
	list_alt: list_alt,
	live_help: live_help,
	live_tv: live_tv,
	living: living,
	local_activity: local_activity,
	local_airport: local_airport,
	local_atm: local_atm,
	local_bar: local_bar,
	local_cafe: local_cafe,
	local_car_wash: local_car_wash,
	local_convenience_store: local_convenience_store,
	local_dining: local_dining,
	local_drink: local_drink,
	local_fire_department: local_fire_department,
	local_florist: local_florist,
	local_gas_station: local_gas_station,
	local_grocery_store: local_grocery_store,
	local_hospital: local_hospital,
	local_hotel: local_hotel,
	local_laundry_service: local_laundry_service,
	local_library: local_library,
	local_mall: local_mall,
	local_movies: local_movies,
	local_offer: local_offer,
	local_parking: local_parking,
	local_pharmacy: local_pharmacy,
	local_phone: local_phone,
	local_pizza: local_pizza,
	local_play: local_play,
	local_police: local_police,
	local_post_office: local_post_office,
	local_printshop: local_printshop,
	local_see: local_see,
	local_shipping: local_shipping,
	local_taxi: local_taxi,
	location_city: location_city,
	location_disabled: location_disabled,
	location_off: location_off,
	location_on: location_on,
	location_searching: location_searching,
	lock: lock,
	lock_clock: lock_clock,
	lock_open: lock_open,
	lock_person: lock_person,
	lock_reset: lock_reset,
	login: login,
	logo_dev: logo_dev,
	logout: logout,
	looks: looks,
	looks3: looks3,
	looks4: looks4,
	looks5: looks5,
	looks6: looks6,
	looks_one: looks_one,
	looks_two: looks_two,
	loop: loop,
	loupe: loupe,
	low_priority: low_priority,
	loyalty: loyalty,
	lte_mobiledata: lte_mobiledata,
	lte_plus_mobiledata: lte_plus_mobiledata,
	luggage: luggage,
	lunch_dining: lunch_dining,
	lyrics: lyrics,
	macro_off: macro_off,
	mail: mail,
	mail_lock: mail_lock,
	mail_outline: mail_outline,
	male: male,
	man: man,
	man2: man2,
	man3: man3,
	man4: man4,
	manage_accounts: manage_accounts,
	manage_history: manage_history,
	manage_search: manage_search,
	map: map,
	maps_home_work: maps_home_work,
	maps_ugc: maps_ugc,
	margin: margin,
	mark_as_unread: mark_as_unread,
	mark_chat_read: mark_chat_read,
	mark_chat_unread: mark_chat_unread,
	mark_email_read: mark_email_read,
	mark_email_unread: mark_email_unread,
	mark_unread_chat_alt: mark_unread_chat_alt,
	markunread: markunread,
	markunread_mailbox: markunread_mailbox,
	masks: masks,
	maximize: maximize,
	media_bluetooth_off: media_bluetooth_off,
	media_bluetooth_on: media_bluetooth_on,
	mediation: mediation,
	medical_information: medical_information,
	medical_services: medical_services,
	medication: medication,
	medication_liquid: medication_liquid,
	meeting_room: meeting_room,
	memory: memory,
	menu: menu,
	menu_book: menu_book,
	menu_open: menu_open,
	merge: merge,
	merge_type: merge_type,
	message: message,
	mic: mic,
	mic_external_off: mic_external_off,
	mic_external_on: mic_external_on,
	mic_none: mic_none,
	mic_off: mic_off,
	microwave: microwave,
	military_tech: military_tech,
	minimize: minimize,
	minor_crash: minor_crash,
	miscellaneous_services: miscellaneous_services,
	missed_video_call: missed_video_call,
	mms: mms,
	mobile_friendly: mobile_friendly,
	mobile_off: mobile_off,
	mobile_screen_share: mobile_screen_share,
	mobiledata_off: mobiledata_off,
	mode: mode,
	mode_comment: mode_comment,
	mode_edit: mode_edit,
	mode_edit_outline: mode_edit_outline,
	mode_fan_off: mode_fan_off,
	mode_night: mode_night,
	mode_of_travel: mode_of_travel,
	mode_standby: mode_standby,
	model_training: model_training,
	monetization_on: monetization_on,
	money: money,
	money_off: money_off,
	money_off_csred: money_off_csred,
	monitor: monitor,
	monitor_heart: monitor_heart,
	monitor_weight: monitor_weight,
	monochrome_photos: monochrome_photos,
	mood: mood,
	mood_bad: mood_bad,
	moped: moped,
	more: more,
	more_horiz: more_horiz,
	more_time: more_time,
	more_vert: more_vert,
	mosque: mosque,
	motion_photos_auto: motion_photos_auto,
	motion_photos_off: motion_photos_off,
	mouse: mouse,
	move_down: move_down,
	move_to_inbox: move_to_inbox,
	move_up: move_up,
	movie: movie,
	movie_creation: movie_creation,
	movie_filter: movie_filter,
	moving: moving,
	mp: mp,
	multiline_chart: multiline_chart,
	multiple_stop: multiple_stop,
	museum: museum,
	music_note: music_note,
	music_off: music_off,
	music_video: music_video,
	my_location: my_location,
	nat: nat,
	nature: nature,
	nature_people: nature_people,
	navigate_before: navigate_before,
	navigate_next: navigate_next,
	navigation: navigation,
	near_me: near_me,
	near_me_disabled: near_me_disabled,
	nearby_error: nearby_error,
	nearby_off: nearby_off,
	nest_cam_wired_stand: nest_cam_wired_stand,
	network_cell: network_cell,
	network_check: network_check,
	network_locked: network_locked,
	network_ping: network_ping,
	network_wifi: network_wifi,
	network_wifi1_bar: network_wifi1_bar,
	network_wifi2_bar: network_wifi2_bar,
	network_wifi3_bar: network_wifi3_bar,
	new_releases: new_releases,
	newspaper: newspaper,
	next_plan: next_plan,
	next_week: next_week,
	nfc: nfc,
	night_shelter: night_shelter,
	nightlife: nightlife,
	nightlight: nightlight,
	nightlight_round: nightlight_round,
	nights_stay: nights_stay,
	no_accounts: no_accounts,
	no_adult_content: no_adult_content,
	no_backpack: no_backpack,
	no_cell: no_cell,
	no_crash: no_crash,
	no_drinks: no_drinks,
	no_encryption: no_encryption,
	no_encryption_gmailerrorred: no_encryption_gmailerrorred,
	no_flash: no_flash,
	no_food: no_food,
	no_luggage: no_luggage,
	no_meals: no_meals,
	no_meeting_room: no_meeting_room,
	no_photography: no_photography,
	no_sim: no_sim,
	no_stroller: no_stroller,
	no_transfer: no_transfer,
	noise_aware: noise_aware,
	noise_control_off: noise_control_off,
	nordic_walking: nordic_walking,
	north: north,
	north_east: north_east,
	north_west: north_west,
	not_accessible: not_accessible,
	not_interested: not_interested,
	not_listed_location: not_listed_location,
	not_started: not_started,
	note: note,
	note_add: note_add,
	note_alt: note_alt,
	notes: notes,
	notification_add: notification_add,
	notification_important: notification_important,
	notifications: notifications,
	notifications_active: notifications_active,
	notifications_none: notifications_none,
	notifications_off: notifications_off,
	notifications_paused: notifications_paused,
	numbers: numbers,
	offline_bolt: offline_bolt,
	offline_pin: offline_pin,
	offline_share: offline_share,
	oil_barrel: oil_barrel,
	on_device_training: on_device_training,
	ondemand_video: ondemand_video,
	online_prediction: online_prediction,
	opacity: opacity,
	open_in_browser: open_in_browser,
	open_in_full: open_in_full,
	open_in_new: open_in_new,
	open_in_newoff: open_in_newoff,
	open_with: open_with,
	other_houses: other_houses,
	outbound: outbound,
	outbox: outbox,
	outdoor_grill: outdoor_grill,
	outlet: outlet,
	output: output,
	padding: padding,
	pages: pages,
	pageview: pageview,
	paid: paid,
	palette: palette,
	pan_tool: pan_tool,
	pan_tool_alt: pan_tool_alt,
	panorama: panorama,
	panorama_fish_eye: panorama_fish_eye,
	panorama_horizontal: panorama_horizontal,
	panorama_horizontal_select: panorama_horizontal_select,
	panorama_photosphere: panorama_photosphere,
	panorama_photosphere_select: panorama_photosphere_select,
	panorama_vertical: panorama_vertical,
	panorama_vertical_select: panorama_vertical_select,
	panorama_wide_angle: panorama_wide_angle,
	panorama_wide_angleselect: panorama_wide_angleselect,
	paragliding: paragliding,
	park: park,
	party_mode: party_mode,
	password: password,
	pattern: pattern,
	pause: pause,
	pause_circle: pause_circle,
	pause_circle_filled: pause_circle_filled,
	pause_circle_outline: pause_circle_outline,
	pause_presentation: pause_presentation,
	payment: payment,
	payments: payments,
	pedal_bike: pedal_bike,
	pending: pending,
	pending_actions: pending_actions,
	pentagon: pentagon,
	people: people,
	people_alt: people_alt,
	people_outline: people_outline,
	percent: percent,
	perm_camera_mic: perm_camera_mic,
	perm_contact_calendar: perm_contact_calendar,
	perm_data_setting: perm_data_setting,
	perm_device_information: perm_device_information,
	perm_identity: perm_identity,
	perm_media: perm_media,
	perm_phone_msg: perm_phone_msg,
	perm_scan_wifi: perm_scan_wifi,
	person: person,
	person2: person2,
	person3: person3,
	person4: person4,
	person_add: person_add,
	person_add_alt: person_add_alt,
	person_add_alt1: person_add_alt1,
	person_add_disabled: person_add_disabled,
	person_off: person_off,
	person_outline: person_outline,
	person_pin: person_pin,
	person_pin_circle: person_pin_circle,
	person_remove: person_remove,
	person_remove_alt1: person_remove_alt1,
	person_search: person_search,
	personal_video: personal_video,
	pest_control: pest_control,
	pest_control_rodent: pest_control_rodent,
	pets: pets,
	phishing: phishing,
	phone: phone,
	phone_android: phone_android,
	phone_bluetooth_speaker: phone_bluetooth_speaker,
	phone_callback: phone_callback,
	phone_disabled: phone_disabled,
	phone_enabled: phone_enabled,
	phone_forwarded: phone_forwarded,
	phone_in_talk: phone_in_talk,
	phone_iphone: phone_iphone,
	phone_locked: phone_locked,
	phone_missed: phone_missed,
	phone_paused: phone_paused,
	phonelink: phonelink,
	phonelink_erase: phonelink_erase,
	phonelink_lock: phonelink_lock,
	phonelink_off: phonelink_off,
	phonelink_ring: phonelink_ring,
	phonelink_setup: phonelink_setup,
	photo: photo,
	photo_album: photo_album,
	photo_camera: photo_camera,
	photo_camera_back: photo_camera_back,
	photo_camera_front: photo_camera_front,
	photo_filter: photo_filter,
	photo_library: photo_library,
	photo_size_selectactual: photo_size_selectactual,
	photo_size_selectlarge: photo_size_selectlarge,
	photo_size_selectsmall: photo_size_selectsmall,
	php: php,
	piano: piano,
	piano_off: piano_off,
	picture_as_pdf: picture_as_pdf,
	picture_in_picture: picture_in_picture,
	picture_in_picturealt: picture_in_picturealt,
	pie_chart: pie_chart,
	pie_chart_outline: pie_chart_outline,
	pin: pin,
	pin_drop: pin_drop,
	pinch: pinch,
	pivot_table_chart: pivot_table_chart,
	pix: pix,
	place: place,
	plagiarism: plagiarism,
	play_arrow: play_arrow,
	play_circle: play_circle,
	play_circle_filled: play_circle_filled,
	play_circle_filledwhite: play_circle_filledwhite,
	play_circle_outline: play_circle_outline,
	play_disabled: play_disabled,
	play_for_work: play_for_work,
	play_lesson: play_lesson,
	playlist_add: playlist_add,
	playlist_add_check: playlist_add_check,
	playlist_add_checkcircle: playlist_add_checkcircle,
	playlist_add_circle: playlist_add_circle,
	playlist_play: playlist_play,
	playlist_remove: playlist_remove,
	plumbing: plumbing,
	plus_one: plus_one,
	podcasts: podcasts,
	point_of_sale: point_of_sale,
	policy: policy,
	poll: poll,
	polyline: polyline,
	pool: pool,
	portable_wifi_off: portable_wifi_off,
	portrait: portrait,
	post_add: post_add,
	power: power,
	power_input: power_input,
	power_off: power_off,
	power_settings_new: power_settings_new,
	precision_manufacturing: precision_manufacturing,
	pregnant_woman: pregnant_woman,
	present_to_all: present_to_all,
	preview: preview,
	price_change: price_change,
	price_check: price_check,
	print: print,
	print_disabled: print_disabled,
	priority_high: priority_high,
	privacy_tip: privacy_tip,
	production_quantity_limits: production_quantity_limits,
	propane: propane,
	propane_tank: propane_tank,
	psychology: psychology,
	psychology_alt: psychology_alt,
	"public": 1,
	public_off: public_off,
	publish: publish,
	published_with_changes: published_with_changes,
	punch_clock: punch_clock,
	push_pin: push_pin,
	qr_code: qr_code,
	qr_code2: qr_code2,
	qr_code_scanner: qr_code_scanner,
	query_builder: query_builder,
	query_stats: query_stats,
	question_answer: question_answer,
	question_mark: question_mark,
	queue: queue,
	queue_music: queue_music,
	queue_play_next: queue_play_next,
	quickreply: quickreply,
	quiz: quiz,
	r_mobiledata: r_mobiledata,
	radar: radar,
	radio: radio,
	radio_button_checked: radio_button_checked,
	radio_button_unchecked: radio_button_unchecked,
	railway_alert: railway_alert,
	ramen_dining: ramen_dining,
	ramp_left: ramp_left,
	ramp_right: ramp_right,
	rate_review: rate_review,
	raw_off: raw_off,
	raw_on: raw_on,
	read_more: read_more,
	receipt: receipt,
	receipt_long: receipt_long,
	recent_actors: recent_actors,
	recommend: recommend,
	record_voice_over: record_voice_over,
	rectangle: rectangle,
	redeem: redeem,
	redo: redo,
	reduce_capacity: reduce_capacity,
	refresh: refresh,
	remember_me: remember_me,
	remove: remove,
	remove_circle: remove_circle,
	remove_circle_outline: remove_circle_outline,
	remove_done: remove_done,
	remove_from_queue: remove_from_queue,
	remove_moderator: remove_moderator,
	remove_red_eye: remove_red_eye,
	remove_road: remove_road,
	remove_shopping_cart: remove_shopping_cart,
	reorder: reorder,
	repartition: repartition,
	repeat: repeat,
	repeat_on: repeat_on,
	repeat_one: repeat_one,
	repeat_one_on: repeat_one_on,
	replay: replay,
	replay10: replay10,
	replay30: replay30,
	replay5: replay5,
	replay_circle_filled: replay_circle_filled,
	reply: reply,
	reply_all: reply_all,
	report: report,
	report_gmailerrorred: report_gmailerrorred,
	report_off: report_off,
	report_problem: report_problem,
	request_page: request_page,
	request_quote: request_quote,
	reset_tv: reset_tv,
	restart_alt: restart_alt,
	restaurant: restaurant,
	restaurant_menu: restaurant_menu,
	restore: restore,
	restore_from_trash: restore_from_trash,
	restore_page: restore_page,
	reviews: reviews,
	rice_bowl: rice_bowl,
	ring_volume: ring_volume,
	rocket: rocket,
	rocket_launch: rocket_launch,
	roller_shades: roller_shades,
	roller_shades_closed: roller_shades_closed,
	roller_skating: roller_skating,
	roofing: roofing,
	room: room,
	room_preferences: room_preferences,
	room_service: room_service,
	rotate_90_degrees_ccw: rotate_90_degrees_ccw,
	rotate_90_degrees_cw: rotate_90_degrees_cw,
	rotate_left: rotate_left,
	rotate_right: rotate_right,
	roundabout_left: roundabout_left,
	roundabout_right: roundabout_right,
	rounded_corner: rounded_corner,
	route: route,
	router: router,
	rowing: rowing,
	rss_feed: rss_feed,
	rsvp: rsvp,
	rtt: rtt,
	rule: rule,
	rule_folder: rule_folder,
	run_circle: run_circle,
	running_with_errors: running_with_errors,
	rv_hookup: rv_hookup,
	safety_check: safety_check,
	safety_divider: safety_divider,
	sailing: sailing,
	sanitizer: sanitizer,
	satellite: satellite,
	satellite_alt: satellite_alt,
	save: save,
	save_alt: save_alt,
	save_as: save_as,
	saved_search: saved_search,
	savings: savings,
	scale: scale,
	scanner: scanner,
	scatter_plot: scatter_plot,
	schedule: schedule,
	schedule_send: schedule_send,
	schema: schema,
	school: school,
	science: science,
	score: score,
	scoreboard: scoreboard,
	screen_lock_landscape: screen_lock_landscape,
	screen_lock_portrait: screen_lock_portrait,
	screen_lock_rotation: screen_lock_rotation,
	screen_rotation: screen_rotation,
	screen_rotation_alt: screen_rotation_alt,
	screen_search_desktop: screen_search_desktop,
	screen_share: screen_share,
	screenshot: screenshot,
	screenshot_monitor: screenshot_monitor,
	scuba_diving: scuba_diving,
	sd: sd,
	sd_card: sd_card,
	sd_card_alert: sd_card_alert,
	sd_storage: sd_storage,
	search: search,
	search_off: search_off,
	security: security,
	security_update: security_update,
	security_update_good: security_update_good,
	security_update_warning: security_update_warning,
	segment: segment,
	select_all: select_all,
	self_improvement: self_improvement,
	sell: sell,
	send: send,
	send_and_archive: send_and_archive,
	send_time_extension: send_time_extension,
	send_to_mobile: send_to_mobile,
	sensor_door: sensor_door,
	sensor_occupied: sensor_occupied,
	sensor_window: sensor_window,
	sensors: sensors,
	sensors_off: sensors_off,
	sentiment_dissatisfied: sentiment_dissatisfied,
	sentiment_neutral: sentiment_neutral,
	sentiment_satisfied: sentiment_satisfied,
	sentiment_satisfied_alt: sentiment_satisfied_alt,
	sentiment_very_dissatisfied: sentiment_very_dissatisfied,
	sentiment_very_satisfied: sentiment_very_satisfied,
	set_meal: set_meal,
	settings: settings,
	settings_accessibility: settings_accessibility,
	settings_applications: settings_applications,
	settings_backup_restore: settings_backup_restore,
	settings_bluetooth: settings_bluetooth,
	settings_brightness: settings_brightness,
	settings_cell: settings_cell,
	settings_ethernet: settings_ethernet,
	settings_input_antenna: settings_input_antenna,
	settings_input_component: settings_input_component,
	settings_input_composite: settings_input_composite,
	settings_input_hdmi: settings_input_hdmi,
	settings_input_svideo: settings_input_svideo,
	settings_overscan: settings_overscan,
	settings_phone: settings_phone,
	settings_power: settings_power,
	settings_remote: settings_remote,
	settings_suggest: settings_suggest,
	settings_system_daydream: settings_system_daydream,
	settings_voice: settings_voice,
	severe_cold: severe_cold,
	shape_line: shape_line,
	share: share,
	share_location: share_location,
	shield: shield,
	shield_moon: shield_moon,
	shop: shop,
	shop2: shop2,
	shop_two: shop_two,
	shopping_bag: shopping_bag,
	shopping_basket: shopping_basket,
	shopping_cart: shopping_cart,
	shopping_cart_checkout: shopping_cart_checkout,
	short_text: short_text,
	shortcut: shortcut,
	show_chart: show_chart,
	shower: shower,
	shuffle: shuffle,
	shuffle_on: shuffle_on,
	shutter_speed: shutter_speed,
	sick: sick,
	sign_language: sign_language,
	signal_cellular_0_bar: signal_cellular_0_bar,
	signal_cellular_4_bar: signal_cellular_4_bar,
	signal_cellular_alt: signal_cellular_alt,
	signal_cellular_alt1bar: signal_cellular_alt1bar,
	signal_cellular_alt2bar: signal_cellular_alt2bar,
	signal_cellular_connected_no_internet_0_bar: signal_cellular_connected_no_internet_0_bar,
	signal_cellular_connected_no_internet_4_bar: signal_cellular_connected_no_internet_4_bar,
	signal_cellular_no_sim: signal_cellular_no_sim,
	signal_cellular_nodata: signal_cellular_nodata,
	signal_cellular_null: signal_cellular_null,
	signal_cellular_off: signal_cellular_off,
	signal_wifi_0_bar: signal_wifi_0_bar,
	signal_wifi_4_bar: signal_wifi_4_bar,
	signal_wifi_4_bar_lock: signal_wifi_4_bar_lock,
	signal_wifi_bad: signal_wifi_bad,
	signal_wifi_connected_no_internet_4: signal_wifi_connected_no_internet_4,
	signal_wifi_off: signal_wifi_off,
	signpost: signpost,
	sim_card: sim_card,
	sim_card_alert: sim_card_alert,
	sim_card_download: sim_card_download,
	single_bed: single_bed,
	sip: sip,
	skateboarding: skateboarding,
	skip_next: skip_next,
	skip_previous: skip_previous,
	sledding: sledding,
	slideshow: slideshow,
	slow_motion_video: slow_motion_video,
	smart_button: smart_button,
	smart_display: smart_display,
	smart_screen: smart_screen,
	smart_toy: smart_toy,
	smartphone: smartphone,
	smoke_free: smoke_free,
	smoking_rooms: smoking_rooms,
	sms: sms,
	sms_failed: sms_failed,
	snippet_folder: snippet_folder,
	snooze: snooze,
	snowboarding: snowboarding,
	snowmobile: snowmobile,
	snowshoeing: snowshoeing,
	soap: soap,
	social_distance: social_distance,
	solar_power: solar_power,
	sort: sort,
	sort_by_alpha: sort_by_alpha,
	sos: sos,
	soup_kitchen: soup_kitchen,
	source: source,
	south: south,
	south_america: south_america,
	south_east: south_east,
	south_west: south_west,
	spa: spa,
	space_bar: space_bar,
	spatial_audio: spatial_audio,
	spatial_audio_off: spatial_audio_off,
	spatial_tracking: spatial_tracking,
	speaker: speaker,
	speaker_group: speaker_group,
	speaker_notes: speaker_notes,
	speaker_notes_off: speaker_notes_off,
	speaker_phone: speaker_phone,
	speed: speed,
	spellcheck: spellcheck,
	splitscreen: splitscreen,
	spoke: spoke,
	sports: sports,
	sports_bar: sports_bar,
	sports_baseball: sports_baseball,
	sports_basketball: sports_basketball,
	sports_cricket: sports_cricket,
	sports_esports: sports_esports,
	sports_football: sports_football,
	sports_golf: sports_golf,
	sports_gymnastics: sports_gymnastics,
	sports_handball: sports_handball,
	sports_hockey: sports_hockey,
	sports_kabaddi: sports_kabaddi,
	sports_martial_arts: sports_martial_arts,
	sports_mma: sports_mma,
	sports_motorsports: sports_motorsports,
	sports_rugby: sports_rugby,
	sports_score: sports_score,
	sports_soccer: sports_soccer,
	sports_tennis: sports_tennis,
	sports_volleyball: sports_volleyball,
	square: square,
	square_foot: square_foot,
	ssid_chart: ssid_chart,
	stacked_bar_chart: stacked_bar_chart,
	stacked_line_chart: stacked_line_chart,
	stadium: stadium,
	stairs: stairs,
	star: star,
	star_border: star_border,
	star_border_purple500: star_border_purple500,
	star_half: star_half,
	star_outline: star_outline,
	star_purple500: star_purple500,
	star_rate: star_rate,
	stars: stars,
	start: start,
	stay_current_landscape: stay_current_landscape,
	stay_current_portrait: stay_current_portrait,
	stay_primary_landscape: stay_primary_landscape,
	stay_primary_portrait: stay_primary_portrait,
	sticky_note_2: sticky_note_2,
	stop: stop,
	stop_circle: stop_circle,
	stop_screen_share: stop_screen_share,
	storage: storage,
	store: store,
	store_mall_directory: store_mall_directory,
	storefront: storefront,
	storm: storm,
	straight: straight,
	straighten: straighten,
	stream: stream,
	streetview: streetview,
	strikethrough_s: strikethrough_s,
	stroller: stroller,
	style: style,
	subdirectory_arrow_left: subdirectory_arrow_left,
	subdirectory_arrow_right: subdirectory_arrow_right,
	subject: subject,
	subscript: subscript,
	subscriptions: subscriptions,
	subtitles: subtitles,
	subtitles_off: subtitles_off,
	subway: subway,
	summarize: summarize,
	superscript: superscript,
	supervised_user_circle: supervised_user_circle,
	supervisor_account: supervisor_account,
	support: support,
	support_agent: support_agent,
	surfing: surfing,
	surround_sound: surround_sound,
	swap_calls: swap_calls,
	swap_horiz: swap_horiz,
	swap_horizontal_circle: swap_horizontal_circle,
	swap_vert: swap_vert,
	swap_vertical_circle: swap_vertical_circle,
	swipe: swipe,
	swipe_down: swipe_down,
	swipe_down_alt: swipe_down_alt,
	swipe_left: swipe_left,
	swipe_left_alt: swipe_left_alt,
	swipe_right: swipe_right,
	swipe_right_alt: swipe_right_alt,
	swipe_up: swipe_up,
	swipe_up_alt: swipe_up_alt,
	swipe_vertical: swipe_vertical,
	switch_access_shortcut: switch_access_shortcut,
	switch_access_shortcutadd: switch_access_shortcutadd,
	switch_account: switch_account,
	switch_camera: switch_camera,
	switch_left: switch_left,
	switch_right: switch_right,
	switch_video: switch_video,
	synagogue: synagogue,
	sync: sync,
	sync_alt: sync_alt,
	sync_disabled: sync_disabled,
	sync_lock: sync_lock,
	sync_problem: sync_problem,
	system_security_update: system_security_update,
	system_security_updategood: system_security_updategood,
	system_security_updatewarning: system_security_updatewarning,
	system_update: system_update,
	system_update_alt: system_update_alt,
	tab: tab,
	tab_unselected: tab_unselected,
	table_bar: table_bar,
	table_chart: table_chart,
	table_restaurant: table_restaurant,
	table_rows: table_rows,
	table_view: table_view,
	tablet: tablet,
	tablet_android: tablet_android,
	tablet_mac: tablet_mac,
	tag: tag,
	tag_faces: tag_faces,
	takeout_dining: takeout_dining,
	tap_and_play: tap_and_play,
	tapas: tapas,
	task: task,
	task_alt: task_alt,
	taxi_alert: taxi_alert,
	temple_buddhist: temple_buddhist,
	temple_hindu: temple_hindu,
	terminal: terminal,
	terrain: terrain,
	text_decrease: text_decrease,
	text_fields: text_fields,
	text_format: text_format,
	text_increase: text_increase,
	text_rotate_up: text_rotate_up,
	text_rotate_vertical: text_rotate_vertical,
	text_rotation_angledown: text_rotation_angledown,
	text_rotation_angleup: text_rotation_angleup,
	text_rotation_down: text_rotation_down,
	text_rotation_none: text_rotation_none,
	text_snippet: text_snippet,
	textsms: textsms,
	texture: texture,
	theater_comedy: theater_comedy,
	theaters: theaters,
	thermostat: thermostat,
	thermostat_auto: thermostat_auto,
	thumb_down: thumb_down,
	thumb_down_alt: thumb_down_alt,
	thumb_down_offalt: thumb_down_offalt,
	thumb_up: thumb_up,
	thumb_up_alt: thumb_up_alt,
	thumb_up_offalt: thumb_up_offalt,
	thumbs_up_down: thumbs_up_down,
	thunderstorm: thunderstorm,
	time_to_leave: time_to_leave,
	timelapse: timelapse,
	timeline: timeline,
	timer: timer,
	timer10: timer10,
	timer10_select: timer10_select,
	timer3: timer3,
	timer3_select: timer3_select,
	timer_off: timer_off,
	tips_and_updates: tips_and_updates,
	tire_repair: tire_repair,
	title: title,
	toc: toc,
	today: today,
	toggle_off: toggle_off,
	toggle_on: toggle_on,
	token: token,
	toll: toll,
	tonality: tonality,
	topic: topic,
	tornado: tornado,
	touch_app: touch_app,
	tour: tour,
	toys: toys,
	track_changes: track_changes,
	traffic: traffic,
	train: train,
	tram: tram,
	transcribe: transcribe,
	transfer_within_a_station: transfer_within_a_station,
	transform: transform,
	transgender: transgender,
	transit_enterexit: transit_enterexit,
	translate: translate,
	travel_explore: travel_explore,
	trending_down: trending_down,
	trending_flat: trending_flat,
	trending_up: trending_up,
	trip_origin: trip_origin,
	troubleshoot: troubleshoot,
	"try": 1,
	tsunami: tsunami,
	tty: tty,
	tune: tune,
	tungsten: tungsten,
	turn_left: turn_left,
	turn_right: turn_right,
	turn_sharp_left: turn_sharp_left,
	turn_sharp_right: turn_sharp_right,
	turn_slight_left: turn_slight_left,
	turn_slight_right: turn_slight_right,
	turned_in: turned_in,
	turned_in_not: turned_in_not,
	tv: tv,
	tv_off: tv_off,
	two_wheeler: two_wheeler,
	type_specimen: type_specimen,
	u_turn_left: u_turn_left,
	u_turn_right: u_turn_right,
	umbrella: umbrella,
	unarchive: unarchive,
	undo: undo,
	unfold_less: unfold_less,
	unfold_less_double: unfold_less_double,
	unfold_more: unfold_more,
	unfold_more_double: unfold_more_double,
	unpublished: unpublished,
	unsubscribe: unsubscribe,
	upcoming: upcoming,
	update: update,
	update_disabled: update_disabled,
	upgrade: upgrade,
	upload: upload,
	upload_file: upload_file,
	usb: usb,
	usb_off: usb_off,
	vaccines: vaccines,
	vape_free: vape_free,
	vaping_rooms: vaping_rooms,
	verified: verified,
	verified_user: verified_user,
	vertical_align_bottom: vertical_align_bottom,
	vertical_align_center: vertical_align_center,
	vertical_align_top: vertical_align_top,
	vertical_shades: vertical_shades,
	vertical_shades_closed: vertical_shades_closed,
	vertical_split: vertical_split,
	vibration: vibration,
	video_call: video_call,
	video_camera_back: video_camera_back,
	video_camera_front: video_camera_front,
	video_chat: video_chat,
	video_file: video_file,
	video_label: video_label,
	video_library: video_library,
	video_settings: video_settings,
	video_stable: video_stable,
	videocam: videocam,
	videocam_off: videocam_off,
	videogame_asset: videogame_asset,
	videogame_asset_off: videogame_asset_off,
	view_agenda: view_agenda,
	view_array: view_array,
	view_carousel: view_carousel,
	view_column: view_column,
	view_comfy: view_comfy,
	view_comfy_alt: view_comfy_alt,
	view_compact: view_compact,
	view_compact_alt: view_compact_alt,
	view_cozy: view_cozy,
	view_day: view_day,
	view_headline: view_headline,
	view_in_ar: view_in_ar,
	view_kanban: view_kanban,
	view_list: view_list,
	view_module: view_module,
	view_quilt: view_quilt,
	view_sidebar: view_sidebar,
	view_stream: view_stream,
	view_timeline: view_timeline,
	view_week: view_week,
	vignette: vignette,
	villa: villa,
	visibility: visibility,
	visibility_off: visibility_off,
	voice_chat: voice_chat,
	voice_over_off: voice_over_off,
	voicemail: voicemail,
	volcano: volcano,
	volume_down: volume_down,
	volume_mute: volume_mute,
	volume_off: volume_off,
	volume_up: volume_up,
	volunteer_activism: volunteer_activism,
	vpn_key: vpn_key,
	vpn_key_off: vpn_key_off,
	vpn_lock: vpn_lock,
	vrpano: vrpano,
	wallet: wallet,
	wallpaper: wallpaper,
	warehouse: warehouse,
	warning: warning,
	warning_amber: warning_amber,
	wash: wash,
	watch: watch,
	watch_later: watch_later,
	watch_off: watch_off,
	water: water,
	water_damage: water_damage,
	waterfall_chart: waterfall_chart,
	waves: waves,
	wb_auto: wb_auto,
	wb_cloudy: wb_cloudy,
	wb_incandescent: wb_incandescent,
	wb_iridescent: wb_iridescent,
	wb_shade: wb_shade,
	wb_sunny: wb_sunny,
	wb_twilight: wb_twilight,
	wc: wc,
	web: web,
	web_asset: web_asset,
	web_asset_off: web_asset_off,
	web_stories: web_stories,
	webhook: webhook,
	weekend: weekend,
	west: west,
	whatshot: whatshot,
	wheelchair_pickup: wheelchair_pickup,
	where_to_vote: where_to_vote,
	widgets: widgets,
	width_full: width_full,
	width_normal: width_normal,
	width_wide: width_wide,
	wifi: wifi,
	wifi1_bar: wifi1_bar,
	wifi2_bar: wifi2_bar,
	wifi_calling: wifi_calling,
	wifi_calling3: wifi_calling3,
	wifi_channel: wifi_channel,
	wifi_find: wifi_find,
	wifi_lock: wifi_lock,
	wifi_off: wifi_off,
	wifi_password: wifi_password,
	wifi_protected_setup: wifi_protected_setup,
	wifi_tethering: wifi_tethering,
	wifi_tethering_error: wifi_tethering_error,
	wifi_tethering_errorrounded: wifi_tethering_errorrounded,
	wifi_tethering_off: wifi_tethering_off,
	wind_power: wind_power,
	window: window$1,
	wine_bar: wine_bar,
	woman: woman,
	woman2: woman2,
	work: work,
	work_history: work_history,
	work_off: work_off,
	work_outline: work_outline,
	workspace_premium: workspace_premium,
	workspaces: workspaces,
	wrap_text: wrap_text,
	wrong_location: wrong_location,
	wysiwyg: wysiwyg,
	yard: yard,
	youtube_searched_for: youtube_searched_for,
	zoom_in: zoom_in,
	zoom_in_map: zoom_in_map,
	zoom_out: zoom_out,
	zoom_out_map: zoom_out_map
};

const pascalToSnakeCase = (text) => {
    return text
        ?.replace(/(.)([A-Z][a-z]+)/, '$1_$2')
        .replace(/([a-z0-9])([A-Z])/, '$1_$2')
        .toLowerCase();
};
const getMuiColor = (color) => {
    switch (color) {
        case 'purple':
            return 'primary';
        case 'green':
            return 'success';
        case 'red':
            return 'error';
        case 'orange':
            return 'warning';
        case 'blue':
            return 'info';
        default:
            return color;
    }
};
const FontIcon = ({ iconName = '', size, color, customColor, customSize, }) => {
    const muiColor = getMuiColor(color);
    const snakeCaseIconName = pascalToSnakeCase(iconName);
    const foundIcon = allowedIcons[snakeCaseIconName];
    const icon = foundIcon ? snakeCaseIconName : 'favorite';
    return (jsx(Icon, { fontSize: size, color: muiColor, sx: { color: customColor, fontSize: customSize }, children: icon }));
};

const AppshellButton = ({ url, text, iconName, variant = 'contained', dataTestId = 'button', size = 'medium', onClick, }) => {
    const externalButtonLink = isLinkExternal(url);
    const buttonAriaLabel = externalButtonLink
        ? `${text} (öppnas i ny flik)`
        : text;
    const getStartIcon = () => {
        if (externalButtonLink) {
            return jsx(FontIcon, { iconName: "launch" });
        }
        else if (iconName) {
            return jsx(FontIcon, { iconName: iconName });
        }
        else
            return false;
    };
    return (jsx(Button, { size: size, target: externalButtonLink ? '_blank' : undefined, rel: externalButtonLink ? 'noreferrer' : undefined, sx: { width: 'fit-content' }, href: url, variant: variant, "aria-label": buttonAriaLabel, startIcon: getStartIcon(), "data-testid": dataTestId, onClick: onClick, ...(externalButtonLink && { component: 'a' }), children: text }));
};

const eventNames$3 = {
    internals: {
        login: 'app-shell:gotoLoginClicked'},
};
const __api_internals__ = {
    eventNames: eventNames$3.internals,
};

var UserType;
(function (UserType) {
    UserType[UserType["client"] = 0] = "client";
    UserType[UserType["customer"] = 1] = "customer";
})(UserType || (UserType = {}));
const eventNames$1 = __api_internals__.eventNames;
const dispatchLoginEvent = ({ redirectUrl, userType, historyAction, }) => {
    window.dispatchEvent(new CustomEvent(eventNames$1.login, {
        bubbles: true,
        detail: { redirectUrl, userType, historyAction },
    }));
};
/**
 * Dispatches event that starts login flow for anställd
 * @param {string} redirectUrl - optional url for where to redirect after login.
 * @param userType - Allows developer to tell the Public-web if a user should find themselves on client login or company login
 */
const goToLogin = (redirectUrl, userType = UserType.client, historyAction = 'push') => {
    dispatchLoginEvent({
        redirectUrl: redirectUrl,
        userType: userType,
        historyAction,
    });
};

const ButtonBox = styled(Paper)(({ theme }) => ({
    display: 'flex',
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    backgroundColor: theme.palette?.surface?.green,
    color: theme.palette.text.primary,
    padding: theme.spacing(3),
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    marginBottom: theme.spacing(5),
    '&:hover': {
        backgroundColor: theme.palette.success.light,
    },
}));
const LoginBlock = ({ content: { description, isLoggedIn }, }) => {
    const redirectToLogin = () => {
        goToLogin(`${window.location.pathname}/${window.location.search}`); // This one does the actual redirection to loginMF in new concept
    };
    if (isLoggedIn) {
        return null;
    }
    return (jsxs(ButtonBox, { elevation: 0, onClick: redirectToLogin, role: "button", tabIndex: 0, "data-testid": "loginblock", children: [jsxs(Box, { display: "flex", justifyContent: "center", alignItems: "center", children: [jsx(LockOutlined, { color: "success", style: { marginRight: '24px' } }), jsxs(Box, { display: "flex", flexWrap: "wrap", alignItems: 'center', children: [jsx(Typography, { variant: "body1", fontWeight: "bold", style: {
                                    marginBottom: 0,
                                    marginRight: '8px',
                                }, children: "Logga in" }), jsx(Typography, { variant: "body2", style: { margin: 0 }, children: description })] })] }), jsx(ChevronRight, { color: "success", fontSize: "medium", style: { marginLeft: '24px' } })] }));
};

const linkFileFormats = [
    'doc',
    'docx',
    'odt',
    'xls',
    'xlsx',
    'xlt',
    'xltx',
    'ods',
    'pdf',
];
const isLinkFile = (href) => {
    if (!href)
        return false;
    const hrefParts = href.split('.');
    return linkFileFormats.indexOf(hrefParts[hrefParts.length - 1]) > -1;
};

const Heading = styled$1(Typography)(({ theme }) => ({
    letterSpacing: '-0.3px',
    display: 'block',
    lineHeight: 1.4,
    margin: 0,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: '1.125rem',
}));
const BulletPointMargin = styled$1(Box)(({ theme }) => ({
    marginLeft: theme.spacing(4.5),
}));
const Body = styled$1(Typography)(({ theme }) => ({
    ...theme.typography.body2,
    fontSize: '1rem',
    display: 'block',
}));
const LinkWrapper = styled$1(Box)(({ theme }) => ({
    display: 'block',
    marginTop: theme.spacing(1),
}));
const TextWrapper = styled$1(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
}));
const AvatarPoint = styled$1(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
}));
const AvatarWrapper = styled$1(Avatar)(({ theme }) => ({
    flexShrink: 0,
    fontWeight: theme.typography.fontWeightMedium,
    backgroundColor: theme.palette.surface?.green,
    color: theme.palette.secondary?.dark,
    height: '48px',
    width: '48px',
}));

const BulletPoint = ({ heading, body, link, }) => {
    return (jsxs(TextWrapper, { children: [jsx(Heading, { component: "span", children: jsx(BulletPointMargin, { children: heading }) }), jsx(Body, { component: "span", children: jsx(BulletPointMargin, { children: body }) }), link?.text && link?.url && (jsx(LinkWrapper, { children: jsx(BulletPointMargin, { children: jsx(AppshellLink, { url: link.url, text: link.text }) }) }))] }));
};

const NumberedPoint = ({ index, heading, body, link, }) => {
    const number = index + 1;
    return (jsxs(AvatarPoint, { children: [jsx(AvatarWrapper, { children: number.toString() }), jsxs(TextWrapper, { children: [jsx(Heading, { component: "span", children: heading }), body && jsx(Body, { component: "span", children: body }), link?.text && link.url && (jsx(LinkWrapper, { children: jsx(AppshellLink, { url: link.url, text: link.text }) }))] })] }));
};

const IconPoint = ({ iconName, heading, body, link, }) => {
    return (jsxs(AvatarPoint, { children: [jsx("span", { "aria-hidden": "true", children: jsx(AvatarWrapper, { "data-testid": 'avatar-wrapper', children: jsx(FontIcon, { iconName: iconName ?? 'favorite' }) }) }), jsxs(TextWrapper, { children: [jsx(Heading, { component: "span", children: heading }), body && jsx(Body, { component: "span", children: body }), link?.url && link.text && (jsx(LinkWrapper, { children: jsx(AppshellLink, { url: link.url, text: link.text }) }))] })] }));
};

const Simple = ({ heading, body, link, }) => (jsxs(TextWrapper, { children: [jsx(Heading, { component: "span", children: heading }), jsx(Body, { component: "span", children: body }), link?.text && link?.url && (jsx(LinkWrapper, { children: jsx(AppshellLink, { url: link.url, text: link.text }) }))] }));

var EListType;
(function (EListType) {
    EListType["bulletpoint"] = "bulletpoint";
    EListType["simple"] = "simple";
    EListType["numbered"] = "numbered";
    EListType["icon"] = "icon";
})(EListType || (EListType = {}));
const BulletListContent = (props) => {
    switch (props.listType) {
        case 'numbered':
            return jsx(NumberedPoint, { ...props });
        case 'icon':
            return jsx(IconPoint, { ...props });
        case 'simple':
            return jsx(Simple, { ...props });
        case 'bulletpoint':
        default:
            return jsx(BulletPoint, { ...props });
    }
};
const ListWrapper = styled(List, {
    shouldForwardProp: (prop) => prop !== 'listType',
})(({ theme, listType }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    listStyle: 'none',
    margin: 0,
    padding: 0,
    ...(listType === 'bulletpoint' && {
        paddingLeft: theme.spacing(4.5),
        listStyle: 'disc',
    }),
}));
const BulletListWrapper = ({ children, listType, }) => {
    return (jsx(Fragment, { children: listType === 'numbered' ? (jsx(ListWrapper, { component: "ol", listType: listType, children: children })) : (jsx(ListWrapper, { component: "ul", listType: listType, children: children })) }));
};
const BulletList = ({ content: { listType, listItems }, }) => {
    if (!listItems || listItems.length === 0) {
        return null;
    }
    return (jsx(BulletListWrapper, { listType: listType, children: listItems.map(({ properties: { heading, body, iconName, link } }, index) => (jsx("li", { children: jsx(BulletListContent, { index: index, listType: listType, heading: heading, body: body, iconName: iconName, link: link }) }, heading))) }));
};

const FileDownload = ({ relLink, label, title = 'Ladda ner', mediaUrl = '', }) => (jsxs(Link, { underline: "hover", href: `${mediaUrl}${relLink}`, title: title, children: [jsx(Downloading, { fontSize: 'medium', color: "primary", sx: { mr: 1, position: 'relative', top: '0.25em' } }), label] }));

const StyledAccordion = styled(Accordion)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderLeft: 0,
    borderRight: 0,
    boxShadow: 'none',
    width: '100%',
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));
const ExpandableList = ({ heading, listItems, variant, mediaUrl, }) => {
    const [expanded, setExpanded] = useState([]);
    const checkIfExpanded = (index) => {
        return expanded.includes(index);
    };
    const toggleExpanded = (index) => {
        if (variant === 'single') {
            checkIfExpanded(index) ? setExpanded([]) : setExpanded([index]);
        }
        else {
            checkIfExpanded(index)
                ? setExpanded(expanded.filter((item) => item !== index))
                : setExpanded([...expanded, index]);
        }
    };
    return (jsxs(Fragment, { children: [heading && (jsx(Typography, { component: "h3", variant: "h6", mb: 1.5, children: heading })), listItems.length > 0 && (jsx(List, { children: listItems.map(({ properties: { heading, body } }, index) => (jsx(ListItem, { children: jsxs(StyledAccordion, { expanded: checkIfExpanded(index), onChange: () => {
                            toggleExpanded(index);
                        }, disableGutters: true, "data-testid": `list-item-${index}`, children: [jsx(AccordionSummary, { id: `expandable-list-item-${heading}`, expandIcon: jsx(ExpandMore, {}), children: jsx(Typography, { variant: "subtitle1", fontSize: 18, children: heading }) }), jsx(AccordionDetails, { children: jsx(HTMLMapper, { mediaUrl: mediaUrl, body: body }) })] }) }, `expandable-list-key-${heading}`))) }))] }));
};

const ExpandableListBlock = ({ content, mediaUrl, }) => {
    const { properties: { expandableItems }, } = content;
    return (jsx(ExpandableList, { mediaUrl: mediaUrl, listItems: expandableItems, variant: "multiple" }));
};

const noCookie = (youtubeLink) => youtubeLink
    .replace('youtu.be', 'youtube.com/embed')
    .replace('watch?v=', 'embed/')
    .replace('youtube.com', 'youtube-nocookie.com')
    .replace('//youtube-nocookie', '//www.youtube-nocookie')
    .concat('?rel=0');

const getHtmlString = (children) => ReactDOMServer.renderToStaticMarkup(domToReact(children));
const baseElementMap = {
    p: ({ renderChildren }) => (jsx(Typography, { variant: "body1", gutterBottom: true, children: renderChildren() })),
    a: ({ children, renderChildren, attribs: { href, title, target = undefined }, mediaUrl, }) => {
        const link = href ?? '';
        const ariaLabel = isLinkExternal(link)
            ? `${title ?? ''} (öppnas i ny flik)`
            : title;
        return isLinkFile(link) ? (jsx(FileDownload, { relLink: link, label: children[0].data, title: title, mediaUrl: mediaUrl })) : (jsxs(Link, { title: title, href: link, target: target, rel: target === '_blank' ? 'noreferrer' : undefined, underline: "hover", ...(title && { 'aria-label': ariaLabel }), children: [(isLinkExternal(link) || target === '_blank') && (jsx(OpenInNew, { fontSize: 'medium', sx: { mr: 1, position: 'relative', top: '0.24em' } })), renderChildren()] }));
    },
    h1: ({ attribs, renderChildren }) => (jsx(Typography, { variant: "h1", gutterBottom: true, ...attribs, children: renderChildren() })),
    h2: ({ attribs, renderChildren }) => (jsx(Typography, { variant: "h2", gutterBottom: true, ...attribs, children: renderChildren() })),
    h3: ({ attribs, renderChildren }) => (jsx(Typography, { variant: "h3", gutterBottom: true, ...attribs, children: renderChildren() })),
    h4: ({ attribs, renderChildren }) => (jsx(Typography, { variant: "h4", gutterBottom: true, ...attribs, children: renderChildren() })),
    h5: ({ attribs, renderChildren }) => (jsx(Typography, { variant: "h5", gutterBottom: true, ...attribs, children: renderChildren() })),
    ul: ({ renderChildren }) => jsx(UnorderedList, { children: renderChildren() }),
    ol: ({ renderChildren }) => jsx(OrderedList, { children: renderChildren() }),
    li: ({ renderChildren }) => (jsx(Typography, { gutterBottom: false, component: "li", variant: "body1", children: renderChildren() })),
    hr: ({ attribs }) => jsx(Divider, { sx: { my: 5 }, ...attribs }),
    img: ({ attribs: { src, alt, width = '100%', height = '100%', class: customClass = '', }, mediaUrl, }) => (jsx(LazyLoadWrapper, { component: 'span', children: jsx("span", { style: {
                height: 'auto',
                maxWidth: '100%',
                marginBottom: '24px',
                display: 'block',
                ...(!width.includes('%')
                    ? { maxWidth: Math.min(parseInt(width, 10), 752) }
                    : null),
            }, className: customClass, children: jsx("img", { style: {
                    objectFit: 'cover',
                    borderRadius: '4px',
                    height: height,
                    width: width,
                    maxWidth: '100%',
                }, src: `${mediaUrl}${getImageQuery(src, !width.includes('%') ? Math.min(parseInt(width, 10), 752) : 752)}`, alt: alt }) }) })),
    iframe: ({ attribs: { src } }) => (jsx(LazyLoadWrapper, { component: "span", children: jsx(Box, { sx: {
                position: 'relative',
                display: 'block',
                paddingBottom: '56.25%',
                /* 16:9 */
                height: 0,
                marginBottom: 1,
                overflow: 'hidden',
                iframe: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                },
            }, children: jsx("iframe", { src: noCookie(src), frameBorder: "0", allow: "encrypted-media", allowFullScreen: true, title: "video" }) }) })),
    bulletlistblock: ({ attribs }) => {
        const content = JSON.parse(attribs['data-content']);
        return jsx(BulletList, { content: { ...content.properties } });
    },
    expandablelistblock: ({ attribs, mediaUrl, }) => {
        const properties = JSON.parse(attribs['data-content']);
        return (jsx(ExpandableListBlock, { mediaUrl: mediaUrl, content: { ...properties } }));
    },
    loginblock: ({ attribs, isLoggedIn }) => {
        const loginContent = JSON.parse(attribs['data-content']);
        const loginDescription = loginContent.properties
            .description;
        return (jsx(LoginBlock, { content: { description: loginDescription, isLoggedIn } }));
    },
    factbox: ({ children, attribs, renderChildren, }) => {
        const niceToKnow = attribs['class'];
        return (jsx(Box, { component: 'article', sx: {
                padding: { xs: 3, lg: 5 },
                mb: 5,
                backgroundColor: niceToKnow ? 'surface.purple' : 'surface.orange',
                borderRadius: 1,
                '> *:last-child': {
                    mb: '0 !important',
                },
            }, children: renderChildren(children) }));
    },
    calltoaction: ({ children, attribs }) => {
        const secondary = attribs['class'];
        const childrenAsHtmlString = getHtmlString(children);
        const linkElement = DOMPurify.sanitize(childrenAsHtmlString, {
            FORBID_TAGS: ['p'],
            KEEP_CONTENT: true,
            RETURN_DOM: true,
        }).querySelector('a');
        if (!linkElement)
            return jsx(Fragment, {});
        return (jsx(AppshellButton, { variant: secondary ? 'outlined' : 'contained', url: linkElement.getAttribute('href'), text: linkElement.textContent, dataTestId: "ctaButton" }));
    },
};

const generateRenderChildren = (defaultChildren, options) => (children = defaultChildren) => domToReact(children, options);

const defaultAllowedTags = [
    'factbox',
    'iframe',
    'testimonialblock',
    'loginblock',
    'bulletlistblock',
    'expandablelistblock',
    'calltoaction',
];
const isEmpty = (obj) => Object.keys(obj).length === 0;
const replaceSelfClosingTags = (html) => {
    // Needed so that the sanitizer doesn't remove data-content attributes
    // when self closing tags exist
    const tags = [
        { original: '&lt;br /&gt;', replacement: '&lt;br&gt;' },
        { original: '&lt;hr /&gt;', replacement: '&lt;hr&gt;' },
        { original: '<br />', replacement: '<br>' },
        { original: '<hr />', replacement: '<hr>' },
    ];
    tags.forEach((tag) => {
        html = html.replaceAll(tag.original, tag.replacement);
    });
    return html;
};
const sanitizeBody = (body, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
replaceValues, allowedTags = []) => {
    const domPurifyConfig = {
        ADD_TAGS: [...defaultAllowedTags, ...allowedTags],
        ADD_ATTR: ['target'],
    };
    const sanitized = DOMPurify.sanitize(replaceSelfClosingTags(body), domPurifyConfig);
    const output = isEmpty(replaceValues)
        ? sanitized
        : sanitized.replace(new RegExp(Object.keys(replaceValues).join('|'), 'gi'), (matched) => replaceValues[matched]);
    return output;
};

const parse = (html, options) => {
    if (typeof html !== 'string') {
        throw new TypeError('First argument must be a string');
    }
    if (!html) {
        return [];
    }
    return domToReact(htmlToDOM(html, options?.htmlparser2 || { lowerCaseAttributeNames: false }), options);
};
const parseBody = (body, elements, options) => {
    const sanitizedBody = sanitizeBody(body, options.replaceValues ?? {}, options.allowedTags);
    const parseOptions = {
        replace: (domNode) => {
            const { attribs, name, children } = domNode;
            const element = elements[name];
            const mediaUrl = options.mediaUrl;
            const isLoggedIn = options.isLoggedIn;
            if (element) {
                const renderChildren = generateRenderChildren(children, parseOptions);
                const parseHTML = (html) => parse(html, parseOptions);
                return element({
                    children,
                    attribs,
                    mediaUrl,
                    isLoggedIn,
                    renderChildren,
                    parseHTML,
                });
            }
        },
    };
    return parse(sanitizedBody, parseOptions);
};

const removeLastElementGutterStyle = {
    '& :last-child': {
        marginBottom: '0 !important',
    },
};
/**
 * Map Epi data to React components
 * @param {string} body - HTML body to map to React components
 * @param {Record<string, any>} [replaceValues={}] - values to replace in body
 * @param {WrapperTypes} [wrapper='span'] - Should the resulting components be wrapped in a span or div?
 * @param {string} className - custom class name for styling from consuming code
 * @param {string} mediaUrl - base url to use for media links
 * @param {boolean} isLoggedIn - session state, logged in or not
 * @param {ElementMap} [elements={}] - Map of elements to extend html mapper with
 * @param {boolean} removeLastElementGutter - Remove the gutter for the last element in the map
 */
const HTMLMapper = ({ body, replaceValues = {}, wrapper = 'span', className, mediaUrl, isLoggedIn, elements = {}, allowedTags, removeLastElementGutter, }) => {
    const composedElementMap = { ...baseElementMap, ...elements };
    const componentType = wrapper;
    return (jsx(Box, { className: className, component: componentType, sx: removeLastElementGutter ? removeLastElementGutterStyle : undefined, children: parseBody(body, composedElementMap, {
            replaceValues,
            mediaUrl,
            isLoggedIn,
            allowedTags,
        }) }));
};

export { ExpandableList, ExpandableListBlock, HTMLMapper };
//# sourceMappingURL=index.esm.js.map
